/**
 * Deutsch.
 *
 * Die Schlüssel kommen aus `cs.js`. Fehlt einer, erscheint der englische Text
 * (und ersatzweise der tschechische), damit eine Lücke auffällt.
 *
 * Diese Übersetzung hat noch niemand gelesen, der die Sprache spricht. Bei
 * trans Themen zählen Anrede und das Vokabular der Transition mehr als
 * anderswo: wenn etwas falsch klingt, sag Bescheid und wir ändern es.
 */
const de = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Zurück',
  'obecne.hledat': 'Suchen',
  'obecne.nacitani': 'Wird geladen…',
  'obecne.zrusit': 'Abbrechen',
  'obecne.ulozit': 'Speichern',
  'obecne.odeslat': 'Senden',
  'obecne.vice': 'Alle anzeigen',
  'obecne.jazyk': 'Sprache',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Ein sicherer Raum für die trans Community, in dem du offen sprechen, Hilfe suchen und Unterstützung von anderen spüren kannst.',
  'auth.prihlaseni': 'Anmelden',
  'auth.registrace': 'Registrieren',
  'auth.email': 'E-Mail',
  'auth.heslo': 'Passwort',
  'auth.emailPriklad': 'du@beispiel.de',
  'auth.prihlasitSe': 'Anmelden',
  'auth.prihlasuji': 'Anmeldung läuft…',
  'auth.zapomenuteHeslo': 'Passwort vergessen?',
  'auth.presGoogle': 'Mit Google anmelden',
  'auth.spatneUdaje': 'E-Mail oder Passwort stimmt nicht',
  'auth.uspech': 'Du bist angemeldet.',
  'auth.googleChyba': 'Die Anmeldung mit Google hat nicht geklappt',
  'auth.obnoveniHesla': 'Passwort zurücksetzen',
  'auth.obnoveniOdeslano': 'Wenn die E-Mail registriert ist, bekommst du einen Link zum Zurücksetzen.',
  'auth.zpetNaPrihlaseni': 'Zurück zur Anmeldung',
  'auth.odeslatOdkaz': 'Link schicken',
  'auth.obnoveniChyba': 'Die E-Mail konnte nicht verschickt werden. Versuch es noch mal.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Noch ein Schritt: dein Code',
  'auth.jesteKodPopis': 'Öffne deine Authenticator-App und übertrage die sechs Ziffern, die sie für Bloom anzeigt.',
  'auth.kod': 'Code',
  'auth.zalozniKodNapoveda': 'Handy nicht zur Hand? Gib einen der Ersatzcodes ein, die du beim Einschalten gespeichert hast.',
  'auth.potvrdit': 'Bestätigen',
  'auth.overuji': 'Wird geprüft…',
  'auth.kodNesedi': 'Dieser Code stimmt nicht',
  'auth.zalozniDochazeji': (p) => `Dir bleiben nur noch ${p.pocet} Ersatzcodes. Erzeuge dir neue im Profil.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'So installierst du Bloom auf deinem Handy',
  'auth.krokyAndroid': [
      'Öffne diese Seite in Chrome',
      'Tippe oben rechts auf die drei Punkte (⋮)',
      'Wähle „Zum Startbildschirm hinzufügen“ oder „App installieren“',
      'Bestätige die Installation',
    ],
  'auth.krokyIos': [
      'Öffne diese Seite in Safari',
      'Tippe unten auf das Teilen-Symbol (□↑)',
      'Scrolle nach unten und wähle „Zum Home-Bildschirm“',
      'Bestätige mit „Hinzufügen“',
    ],
  'auth.seznamChranene': [
      { silne: 'Über die Mitglieder ist nichts öffentlich.', text: 'Profile, Geschichten, Angebote, Fragen, Fotos und Avatare bekommen nur angemeldete Personen zu sehen. Nichts davon lässt sich ohne Konto herunterladen oder absammeln.' },
      { silne: 'Niemand kennt dein Passwort', text: '— wir auch nicht. Gespeichert wird ein bcrypt-Hash, aus dem sich das Original nicht zurückrechnen lässt.' },
      { silne: 'Private Nachrichten und Anhänge sind verschlüsselt', text: '(AES + Integritätsprüfung) schon auf der Festplatte des Servers. Wer ein Backup oder die Platte bekäme, läse nur sinnlose Zeichen.' },
      { silne: 'Nachrichten löschen sich selbst', text: 'nach einer Weile (standardmäßig 90 Tage), auch Sprachnachrichten und Fotos. Was nicht da ist, kann nicht durchsickern.' },
      { silne: 'Deine Transitionsphase ist privat', text: 'bis du sie selbst veröffentlichst. Die Schritte, die du im Wegweiser abhakst, sieht sonst niemand.' },
      { silne: 'E-Mail und Telefon', text: 'werden anderen Mitgliedern nie gezeigt.' },
      { silne: '', text: 'Die Anmeldung ist gegen Passwortraten geschützt: die Zahl der Versuche ist begrenzt.' },
      { silne: 'Ende-zu-Ende-Verschlüsselung der Nachrichten.', text: 'Wenn du sie einschaltest, werden Text und Anhänge in deinem eigenen Browser verschlüsselt und der Server bekommt nur unlesbare Zeichen. Der Schlüssel wird mit deinem Passwort geöffnet und verlässt dein Gerät nie — deshalb können auch wir den Inhalt nicht lesen, selbst wenn ein Gericht danach fragte. Der Preis: wenn du dein Passwort vergisst, kommst auch du an alte Nachrichten nicht mehr heran.' },
      { silne: '', text: 'Die Anmeldung bleibt nicht bestehen: Bloom meldet dich ab, wenn du das Fenster schließt, und nach zehn Minuten ohne Aktivität.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Metadaten', text: '— wer wem wann geschrieben hat — muss der Server kennen, sonst könnte er die Nachricht nicht zustellen. Ende-zu-Ende-Verschlüsselung verbirgt das nicht, Signal auch nicht.' },
      { silne: '', text: 'Bloom ist eine Web-App und lädt seinen Verschlüsselungscode bei jedem Öffnen von unserem Server. Wer den Server übernähme, könnte theoretisch veränderten Code ausliefern. Dagegen hilft nur eine signierte App aus einem Store — deshalb hat Signal eine und eine Web-Version nicht.' },
      { silne: 'Profile', text: '— Nickname, Beschreibung, Avatar — lassen sich nicht verschlüsseln, weil der Server sie anderen zeigen muss.' },
      { silne: '', text: 'Nachrichten von vor dem Einschalten der Verschlüsselung bleiben nur auf der Serverplatte verschlüsselt, nicht Ende zu Ende.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom funktioniert wie eine App, auch offline. Deine Daten sind immer aktuell.',
  'auth.zabezpeceniTitulek': 'Wie Bloom abgesichert ist',
  'auth.zabezpeceniUvod': 'Bloom ist ein Raum für die trans Community, hier treffen also empfindliche Dinge aufeinander. Unten steht, was '
      + 'wir zu ihrem Schutz tun — und was wir nicht können — ohne Schönfärberei.',
  'auth.coJeChranene': 'Was geschützt ist',
  'auth.coNeumime': 'Was Bloom nicht kann — und es ist fair, das zu sagen',
  'auth.zabezpeceniZaver': 'Wenn du eine Frage zum Datenschutz hast oder eine Lücke gefunden hast, nutze unten „Problem melden“. Wir nehmen das ernst.',
  'auth.mvp': 'Bloom ist in der ersten Fassung und wir verbessern es gemeinsam mit der Community. '
      + 'Wenn du auf einen Fehler stößt oder eine Idee hast, freuen wir uns darüber.',
  'auth.nahlasitProblem': 'Problem melden',
  'auth.clenu': (p) => (p.pocet === 1 ? 'Mitglied' : 'Mitglieder'),
  'auth.prispevku': (p) => (p.pocet === 1 ? 'Beitrag' : 'Beiträge'),
  'auth.odborniku': (p) => (p.pocet === 1 ? 'Fachperson' : 'Fachpersonen'),
  'auth.nabidek': (p) => (p.pocet === 1 ? 'Angebot' : 'Angebote'),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Nickname (eindeutig)',
  'reg.prezdivkaPriklad': 'Mindestens 3 Zeichen',
  'reg.telefon': 'Telefon',
  'reg.volitelne': '(optional)',
  'reg.heslo': 'Passwort',
  'reg.hesloZnovu': 'Passwort wiederholen',
  'reg.zajmeno': 'Pronomen',
  'reg.oMne': 'Über mich',
  'reg.oMnePriklad': 'Ein paar Worte über dich…',
  'reg.registrovat': 'Konto anlegen',
  'reg.registruji': 'Konto wird angelegt…',
  'reg.presGoogle': 'Mit Google registrieren',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'Oder lade dein eigenes Foto hoch',
  'reg.nahratFoto': 'Foto hochladen',
  'reg.vlastni': 'Eigenes',
  'reg.zeme': 'Land',
  'reg.kraj': 'Region',
  'reg.nechciUvadet': 'Möchte ich nicht angeben',
  'reg.cesko': 'Tschechien',
  'reg.svet': 'Restliche Welt',

  // skupiny avatarů
  'reg.avatarFem': 'Feminin',
  'reg.avatarMask': 'Maskulin',
  'reg.avatarNeutr': 'Neutral',
  'reg.avatarZvirata': 'Tiere',

  // komunitní heslo
  'reg.komunitniHeslo': 'Community-Passwort',
  'reg.komunitniHesloPriklad': 'Community-Passwort eingeben…',
  'reg.komunitniHesloPopis': 'Bloom ist ein privater Raum für die trans Community. Jemand aus der Community kann dir das Passwort geben.',
  'reg.napisAdminovi': 'Wenn du niemanden kennst, schreib der Administration an',
  'reg.nevimHeslo': 'Ich kenne das Community-Passwort nicht',
  'reg.jakZiskat': 'Das Community-Passwort schützt diesen privaten Raum. So bekommst du es:',
  'reg.krok1': '1. Schreib eine E-Mail an',
  'reg.krok2': '2. Stell dich kurz vor und sag, wie du von Bloom erfahren hast',
  'reg.krok3': '3. Die Administration antwortet, so schnell es geht',

  // kontrola hesla
  'reg.hesloKratke': 'Das Passwort muss mindestens 8 Zeichen haben',
  'reg.hesloMale': 'Das Passwort muss einen Kleinbuchstaben enthalten',
  'reg.hesloVelke': 'Das Passwort muss einen Großbuchstaben enthalten',
  'reg.hesloCislo': 'Das Passwort muss eine Ziffer enthalten',
  'reg.hesloZnak': 'Das Passwort muss ein Sonderzeichen enthalten (!@#$%…)',
  'reg.pozadavek8': 'Mindestens 8 Zeichen',
  'reg.pozadavekVelke': 'Großbuchstabe',
  'reg.pozadavekCislo': 'Ziffer',
  'reg.pozadavekZnak': 'Sonderzeichen (!@#$%)',
  'reg.hesloNesouhlasi': 'Die Passwörter stimmen nicht überein',
  'reg.prezdivkaKratka': 'Der Nickname muss mindestens 3 Zeichen haben',
  'reg.hesloPovinne': 'Das Community-Passwort ist nötig',
  'reg.hotovo': 'Konto angelegt. Schau in deine E-Mails, um es zu bestätigen.',
  'reg.fotoVelka': 'Das Bild ist zu groß (max. 2 MB)',
  'reg.chyba': 'Das Konto konnte nicht angelegt werden',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Hier muss niemand perfekt sein. Bloom ist ein Raum, in dem alle sie selbst sein können — '
      + 'wo du deine Erfahrung teilen, fragen und anderen helfen kannst. Ohne Urteil und ohne Vorurteile.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · aus dem Tschechischen übersetzt',
  'domu.vitej': 'Hallo,',
  'domu.vCislech': 'Bloom in Zahlen',
  'domu.noveVKomunite': 'Zum ersten Mal hier?',
  'domu.noveVKomunitePopis1': 'Du musst nicht sichtbar sein. Du brauchst kein Foto. Du musst nicht geoutet sein.',
  'domu.noveVKomunitePopis2': 'Bloom ist ein Raum, in dem du in deinem Tempo anfangen kannst.',
  'domu.rozcestnik1': 'Ich bin zum ersten Mal hier',
  'domu.rozcestnik2': 'Ich weiß nicht, wo ich anfangen soll',
  'domu.rozcestnik3': 'Ich möchte anonym bleiben',
  'domu.rozcestnik4': 'Ich suche Fachpersonen',
  'domu.rozcestnik5': 'Ich will nur Erfahrungen lesen',
  'domu.otazky': 'Fragen oder willst du mehr wissen? Schreib uns an',
  'domu.doporucujeme': 'Empfohlen',
  'domu.odbornici': 'Fachpersonen',
  'domu.noviClenove': 'Neu in der Community',
  'domu.zadniNovi': 'Noch niemand Neues',
  'domu.nejnovejsiOtazky': 'Neueste Fragen',
  'domu.zadneOtazky': 'Noch keine Fragen.',
  'domu.nejlepeHodnoceni': 'Am besten bewertete Fachpersonen',
  'domu.zadniHodnoceni': 'Noch keine Bewertungen',
  'domu.zadneAktuality': 'Noch keine Neuigkeiten',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Biete an, was du kannst, und bekomm Hilfe von anderen.',
  'domu.dlazdice.specialists': 'Finde geprüfte Fachpersonen, von Psychologie bis plastische Chirurgie.',
  'domu.dlazdice.legal': 'Rechtliche Hilfe, Artikel und Antworten auf deine Fragen.',
  'domu.dlazdice.nearby': 'Angebote und Fachpersonen in deiner Nähe.',

  // počty
  'domu.pocetClenu': (p) => (p.pocet === 1 ? 'Mitglied der Community' : 'Mitglieder der Community'),
  'domu.pocetZkusenosti': (p) => (p.pocet === 1 ? 'geteilte Erfahrung' : 'geteilte Erfahrungen'),
  'domu.pocetOdborniku': (p) => (p.pocet === 1 ? 'geprüfte Fachperson' : 'geprüfte Fachpersonen'),
  'domu.pocetNabidek': (p) => (p.pocet === 1 ? 'Angebot zur Unterstützung' : 'Angebote zur Unterstützung'),

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Start',
  'nav.news': 'Aktuelles',
  'nav.stories': 'Erfahrungen der Community',
  'nav.mapaSveta': 'Weltkarte',
  'nav.support': 'Gegenseitige Hilfe',
  'nav.specialists': 'Trans-freundliche Fachpersonen',
  'nav.legal': 'Rechtliche Hilfe',
  'nav.pageants': 'Wettbewerbe',
  'nav.nearby': 'In meiner Nähe',
  'nav.hledat': 'In Bloom suchen',
  'nav.hledatPlaceholder': 'Personen, Fachpersonen, Artikel suchen…',
  'nav.zpravy': 'Nachrichten',
  'nav.profil': 'Mein Profil',
  'nav.mojeCesta': 'Mein Weg',
  'nav.administrace': 'Verwaltung',
  'nav.odhlasit': 'Abmelden',
  'nav.vsechnyVysledky': (p) => `Alle Ergebnisse für „${p.dotaz}“ anzeigen`,
  'nav.overEmail': 'Bestätige deine E-Mail',
  'nav.menu': 'Menü',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom in der Welt',
  'svet.podtitulek': 'Wähle ein Land und sieh, was die Community dort gesammelt hat.',
  'svet.hledatZemi': 'Land suchen…',
  'svet.vsechnyZeme': 'Alle Länder',
  'svet.jenSObsahem': 'Nur Länder mit Inhalten',
  'svet.nicNenalezeno': 'Kein Land passt.',
  'svet.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'Eintrag' : 'Einträge'}`,
  'svet.prazdnaZeme': 'Noch nichts',
  'svet.kontinent': 'Kontinent',
  'svet.celySvet': 'Ganze Welt',
  'svet.vse': 'Alles',
  'svet.zacniDomovem': 'Fang damit an, das Land zu wählen, in dem du zu Hause bist. Du kannst es auch aus der Liste unter der Karte wählen.',
  'svet.zkoumej': 'Wähle ein Land und sieh, was Bloom dort hat. Du kannst überall stöbern — '
      + 'dein Heimatland ändert sich dadurch nicht.',
  'svet.domov': 'Zu Hause',
  'svet.zrusitDomov': 'Heimatland entfernen',
  'svet.nastavitDomov': 'Als mein Land festlegen',
  'svet.zeSveta': 'Aus aller Welt',
  'svet.coSeChysta': 'Was ansteht',
  'svet.souteze': 'Wettbewerbe mit offener Anmeldung',
  'svet.noveOrganizace': 'Neue Organisationen',
  'svet.kdeJizNeco': 'Wo Bloom schon etwas hat',
  'svet.hledatZemiPopisek': 'Land suchen',
  'svet.nicNeodpovida': 'Nichts passt. Versuch eine andere Suche.',
  'svet.napovedaKMape': 'Zieh die Karte, um sie zu bewegen, und zoome mit dem Rad oder den Knöpfen. Du musst sie '
      + 'nicht benutzen — Suche und die vollständige Länderliste stehen darunter.',
  'svet.tvujBloom': (p) => `Dein Bloom in ${p.zeme}`,
  'svet.tvojeDomovska': 'dein Heimatland',
  'svet.zemi': (p) => `${p.pocet} ${p.pocet === 1 ? 'Land' : 'Länder'}`,
  'svet.chyba': 'Die Länder konnten nicht geladen werden. Lade die Seite neu.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${p.pocet === 1 ? 'Fachperson' : 'Fachpersonen'}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${p.pocet === 1 ? 'Organisation' : 'Organisationen'}`,
  'svet.pocet.events': (p) => `${p.pocet} ${p.pocet === 1 ? 'Veranstaltung' : 'Veranstaltungen'}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${p.pocet === 1 ? 'Wettbewerb' : 'Wettbewerbe'}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${p.pocet === 1 ? 'Ressource' : 'Ressourcen'}`,

  // světadíly
  'kontinent.europe': 'Europa',
  'kontinent.asia': 'Asien',
  'kontinent.africa': 'Afrika',
  'kontinent.north_america': 'Nordamerika',
  'kontinent.south_america': 'Südamerika',
  'kontinent.oceania': 'Ozeanien',
  'kontinent.antarctica': 'Antarktis',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Trans Wettbewerbe aus aller Welt. Die, bei denen du dich noch anmelden kannst, stehen oben.',
  'souteze.hledat': 'Wettbewerb suchen…',
  'souteze.zadne': 'Wir haben noch keine Wettbewerbe. Kennst du einen? Schick einen Vorschlag.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `${p.zeme} öffnen`,
  'nahled.zavrit': 'Vorschau schließen',
  'nahled.jenInformace': 'Bisher haben wir nur Informationen über das Land.',
  'nahled.zatimNic': 'Wir haben hier noch keine Kontakte, Organisationen oder Veranstaltungen. Kennst du etwas? Schick einen Vorschlag.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom in ${p.zeme}`,
  'zeme.podtitulek': (p) => `Was die Community in ${p.zeme} gesammelt hat.`,
  'zeme.prazdna': 'Bloom fängt hier gerade erst an. Du könntest die erste Person sein, die etwas hinzufügt.',
  'zeme.mapaSveta': 'Weltkarte',
  'zeme.navrhnout': 'Eintrag vorschlagen',
  'zeme.domovska': 'Dein Heimatland',
  'zeme.nastavitDomovskou': 'Als mein Land festlegen',
  'zeme.kdeToJe': 'Wo es zu finden ist',
  'zeme.coTuBude': 'Was du hier findest',
  'zeme.zatimPrazdne': 'bisher leer',
  'zeme.pripravujeme': 'in Vorbereitung',
  'zeme.zobrazitVse': (p) => `Alle anzeigen (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom wächst hier gerade erst',
  'zeme.rostePopis': 'Wir haben hier noch nichts. Kennst du eine Organisation, eine Veranstaltung oder einen '
      + 'nützlichen Kontakt? Schick einen Vorschlag — er geht durch eine Prüfung und erscheint dann hier.',
  'zeme.jinouZemi': 'Andere Länder ansehen',
  'zeme.bezKontaktu': 'Wir haben hier noch keine Kontakte oder Organisationen.',
  'zeme.bezKontaktuPopis': 'Kennst du hier jemanden oder etwas Nützliches? Schick einen Vorschlag — er geht '
      + 'durch eine Prüfung und erscheint dann hier.',
  'zeme.neznama': 'Dieses Land kennen wir nicht.',
  'zeme.chyba': 'Das Land konnte nicht geladen werden.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Praxen und Kliniken',
  'sekce.specialists.popis': 'Ärzt:innen, Kliniken und andere Fachpersonen, mit denen die Community Erfahrung hat.',
  'sekce.organizations': 'Organisationen',
  'sekce.organizations.popis': 'Vereine, gemeinnützige Träger und Selbsthilfegruppen.',
  'sekce.events': 'Veranstaltungen',
  'sekce.events.popis': 'Treffen, Pride, Workshops und Konferenzen.',
  'sekce.pageants': 'Wettbewerbe',
  'sekce.pageants.popis': 'Trans Wettbewerbe und ihre Termine.',
  'sekce.resources': 'Ressourcen',
  'sekce.resources.popis': 'Praktische Informationen zu diesem Land.',
  'sekce.community': 'Community',
  'sekce.community.popis': 'Menschen und Gruppen in diesem Land.',
  'sekce.legal': 'Rechtliche Hilfe',
  'sekce.legal.popis': 'Informationen und Unterstützung für die trans Community',
  'sekce.support': 'Gegenseitige Hilfe',
  'sekce.support.popis': 'Biete an, was du kannst, und bekomm Hilfe von anderen aus der Community',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'In diesem Land suchen…',
  'vypis.vsechnyKategorie': 'Alle Kategorien',
  'vypis.kategorie': 'Kategorie',
  'vypis.celaZeme': 'Ganzes Land',
  'vypis.navrhnout': 'Vorschlagen',
  'vypis.nicNeodpovida': 'Nichts passt. Versuch eine andere Suche oder nimm den Filter weg.',
  'vypis.zadneZaznamy': (p) => `Wir haben noch keine Einträge in ${p.zeme}.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'Eintrag' : 'Einträge'}`,
  'vypis.predchozi': 'Zurück',
  'vypis.dalsi': 'Weiter',
  'vypis.chyba': 'Die Einträge konnten nicht geladen werden.',
  'vypis.neznamyDruh': 'Diese Art von Eintrag kennen wir nicht.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Zurück zu ${p.zeme}`,
  'detail.kontakty': 'Kontakt und Links',
  'detail.podrobnosti': 'Details',
  'detail.zacatek': 'Beginn',
  'detail.termin': 'Termin',
  'detail.uzaverka': 'Anmeldeschluss',
  'detail.prihlaska': 'Anmeldung',
  'detail.strankaAkce': 'Seite der Veranstaltung',
  'detail.web': 'Website',
  'detail.konec': 'Ende',
  'detail.stavRocniku': 'Stand der Ausgabe',
  'detail.oblasti': 'Arbeitsbereiche',
  'detail.coNabizi': 'Was sie anbieten',
  'detail.kategorie': 'Kategorien',
  'detail.jazyky': 'Sprachen',
  'detail.vitezove': 'Frühere Gewinnerinnen',
  'detail.kdoSeMuze': 'Wer teilnehmen kann',
  'detail.poradatel': 'Veranstaltung',
  'detail.poplatek': 'Gebühr',
  'detail.tema': 'Thema',
  'detail.forma.offline': 'Vor Ort',
  'detail.forma.online': 'Online',
  'detail.forma.hybrid': 'Vor Ort und online',
  'detail.rozsah.local': 'Lokal',
  'detail.rozsah.national': 'National',
  'detail.rozsah.international': 'International',
  'detail.rocnik.upcoming': 'Kommt noch',
  'detail.rocnik.registration_open': 'Anmeldung offen',
  'detail.rocnik.registration_closed': 'Anmeldung geschlossen',
  'detail.rocnik.completed': 'Vorbei',
  'detail.zdroj': (p) => `Quelle: ${p.zdroj}`,
  'detail.upraveno': (p) => `Zuletzt aktualisiert: ${p.datum}`,
  'detail.overeno': 'Geprüft, dass die Angaben stimmen. Das ist keine Empfehlung von Bloom.',
  'detail.neovereno': 'Dieser Eintrag ist noch nicht geprüft. Die Angaben können sich geändert haben — schau bei der Quelle nach.',
  'detail.nenalezen': 'Diesen Eintrag kennen wir nicht. Vielleicht wurde er gelöscht oder wartet noch auf die Prüfung.',
  'detail.chyba': 'Der Eintrag konnte nicht geladen werden.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Was hier gilt',
  'profil.name_change': 'Namensänderung',
  'profil.gender_marker': 'Änderung des Geschlechtseintrags',
  'profil.surgery_required': 'Operation vorausgesetzt',
  'profil.healthcare': 'Zugang zur Gesundheitsversorgung',
  'profil.legal_protection': 'Schutz vor Diskriminierung',
  'profil.safety': 'Sicherheit',
  'profil.stav.yes': 'Ja',
  'profil.stav.limited': 'Teilweise',
  'profil.stav.no': 'Nein',
  'profil.stav.unknown': 'Keine Angaben',
  'profil.zdroj': 'Quelle',
  'profil.zdrojZRoku': (p) => `Quelle von ${p.rok}`,
  'profil.overeno': (p) => `Geprüft am ${p.datum}`,
  'profil.zmena': 'Neue Änderung',
  'profil.odKdy': (p) => `gilt seit ${p.datum}`,
  'profil.doklady': 'Quellen',
  'profil.zakon': 'Gesetz oder Gericht',
  'profil.upozorneni': 'Das ist keine Rechtsberatung. Gesetze ändern sich und vieles hängt von deiner konkreten '
      + 'Situation ab — schau bei der Quelle nach oder frag eine Organisation in dem '
      + 'Land, bevor du danach handelst.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `${p.druh} vorschlagen${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Dein Vorschlag geht durch eine Prüfung, bevor er in Bloom erscheint. Füll aus, was '
      + 'du weißt — den Rest ergänzen wir.',
  'navrh.jednotne.organizations': 'eine Organisation',
  'navrh.jednotne.events': 'eine Veranstaltung',
  'navrh.jednotne.pageants': 'einen Wettbewerb',
  'navrh.jednotne.resources': 'eine Ressource',
  'navrh.popis.organizations': 'Ein Verein, ein gemeinnütziger Träger oder eine Selbsthilfegruppe.',
  'navrh.popis.events': 'Ein Treffen, eine Pride, ein Workshop, eine Konferenz.',
  'navrh.popis.pageants': 'Ein trans Wettbewerb – Termin, Anmeldung, Veranstaltung.',
  'navrh.popis.resources': 'Praktische Information – Gesundheit, Recht, Dokumente, Kontakte.',
  'navrh.nazev': 'Name',
  'navrh.popisPole': 'Beschreibung',
  'navrh.zeme': 'Land',
  'navrh.mesto': 'Stadt',
  'navrh.adresa': 'Adresse',
  'navrh.web': 'Website',
  'navrh.email': 'E-Mail',
  'navrh.telefon': 'Telefon',
  'navrh.odkudVis': 'Woher du das weißt',
  'navrh.odkudVisPriklad': 'z. B. von ihrer Website, ich war da…',
  'navrh.vyberte': '— auswählen —',
  'navrh.forma': 'Format',
  'navrh.rozsah': 'Reichweite',
  'navrh.platiPro': 'Gilt für',
  'navrh.platnost.global': 'Die ganze Welt',
  'navrh.platnost.country': 'Ein Land',
  'navrh.platnost.region': 'Eine Region',
  'navrh.platnost.city': 'Eine Stadt',
  'navrh.odkazAkce': 'Link zur Veranstaltung',
  'navrh.odkazPrihlaska': 'Link zur Anmeldung',
  'navrh.odkazy': 'Links',
  'navrh.text': 'Text',
  'navrh.odeslat': 'Vorschlag schicken',
  'navrh.odesilam': 'Wird geschickt…',
  'navrh.chyba': 'Der Vorschlag konnte nicht geschickt werden',
  'navrh.dikyTitulek': 'Danke, wir haben es',
  'navrh.dikyPopis': 'Wir haben deinen Vorschlag bekommen. Jemand von uns schaut ihn an und dann erscheint er '
      + 'in Bloom. Nichts wird automatisch veröffentlicht.',
  'navrh.zavrit': 'Schließen',
  'navrh.seznamNapoveda': 'Trenne die Einträge mit Kommas.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `Gehört ${p.druh} dir?`,
  'prevzeti.popis': 'Du kannst das Profil übernehmen und die Angaben aktuell halten. '
      + 'Die Anfrage geht zuerst durch eine Prüfung.',
  'prevzeti.tlacitko': 'Dieses Profil übernehmen',
  'prevzeti.spravujes': 'Du verwaltest dieses Profil. Du kannst die Angaben jederzeit korrigieren — Änderungen gelten sofort.',
  'prevzeti.upravit': 'Angaben bearbeiten',
  'prevzeti.spravujeSama': (p) => `Dieses Profil verwaltet ${p.druh} selbst.`,
  'prevzeti.ceka': 'Wir haben deine Anfrage bekommen und schauen sie uns an.',
  'prevzeti.formulacTitulek': (p) => `Profil übernehmen — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Bevor wir das Profil übergeben, müssen wir wissen, dass du wirklich zu der '
      + 'Organisation gehörst. Die Anfrage geht durch eine Prüfung; vorerst ändert sich nichts.',
  'prevzeti.role': 'Welche Rolle hast du dort?',
  'prevzeti.rolePriklad': 'z. B. Koordination, Vorsitz des Vereins',
  'prevzeti.doklad': 'Wie können wir das prüfen?',
  'prevzeti.dokladPriklad': 'z. B. ich stehe auf der Website der Organisation unter Kontakte; oder schreib von einer offiziellen Adresse',
  'prevzeti.dokladNapoveda': 'Ein Link auf eine Seite, auf der du stehst, reicht — oder die offizielle Adresse '
      + 'der Organisation, von der aus du schreibst.',
  'prevzeti.kontakt': 'Dein Kontakt',
  'prevzeti.kontaktPriklad': 'E-Mail oder Telefon',
  'prevzeti.dalsi': 'Sonst noch etwas',
  'prevzeti.nepovinne': '(optional)',
  'prevzeti.odeslat': 'Anfrage schicken',
  'prevzeti.odesilam': 'Wird geschickt…',
  'prevzeti.vyplnObe': 'Sag uns, welche Rolle du hast und wie sich das prüfen lässt.',
  'prevzeti.prijato': 'Danke. Wir haben deine Anfrage bekommen und melden uns.',
  'prevzeti.chyba': 'Die Anfrage konnte nicht geschickt werden.',
  'prevzeti.upravaTitulek': (p) => `Profil bearbeiten — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Name und Ort stehen absichtlich nicht hier: nach ihnen wird gesucht und '
      + 'sortiert. Wenn sie sich geändert haben, schreib uns und wir aktualisieren sie.',
  'prevzeti.popisPole': 'Beschreibung',
  'prevzeti.email': 'E-Mail',
  'prevzeti.telefon': 'Telefon',
  'prevzeti.web': 'Website',
  'prevzeti.ulozeno': 'Gespeichert.',
  'prevzeti.ukladam': 'Wird gespeichert…',
  'prevzeti.chybaUlozeni': 'Speichern hat nicht geklappt.',
  'prevzeti.druh.organizations': 'die Organisation',
  'prevzeti.druh.events': 'die Veranstaltung',
  'prevzeti.druh.pageants': 'der Wettbewerb',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Bearbeite deine Angaben und Einstellungen',
  'profil.overeny': 'Bestätigt',
  'profil.neovereny': 'Nicht bestätigt',
  'profil.overteEmail': 'Bestätige bitte deine E-Mail. Ein unbestätigtes Konto hat eingeschränkte Rechte.',
  'profil.emailOdeslan': 'Bestätigungs-E-Mail verschickt.',
  'profil.emailChyba': 'Die E-Mail konnte nicht verschickt werden',
  'profil.odeslano': 'Verschickt.',
  'profil.overeniOdbornika': 'Prüfung als Fachperson oder Jurist:in',
  'profil.pracujeteVOboru': 'Arbeitest du in dem Bereich? Hol dir ein geprüftes Abzeichen.',
  'profil.zadostOdeslana': 'Anfrage verschickt',
  'profil.pozadatOOvereni': 'Prüfung beantragen',
  'profil.zadostTitulek': 'Prüfung als Fachperson oder Jurist:in beantragen',
  'profil.zadostPopis': 'Füll die Angaben zu deiner Anfrage aus. Die Moderation schaut sie sich an.',
  'profil.pozadovanaRole': 'Beantragte Rolle',
  'profil.roleOdbornik': 'Fachperson',
  'profil.rolePravnik': 'Jurist:in',
  'profil.specializace': 'Fachgebiet',
  'profil.odkazNaProfil': 'Link auf ein berufliches Profil',
  'profil.zpravaProAdmina': 'Eine kurze Nachricht an die Administration',
  'profil.odesilam': 'Wird geschickt…',
  'profil.odeslatZadost': 'Prüfungsanfrage schicken',
  'profil.vyplnteSpecializaci': 'Füll bitte dein Fachgebiet aus',
  'profil.zadostUspech': 'Deine Prüfungsanfrage ist verschickt.',
  'profil.zadostChyba': 'Die Anfrage konnte nicht verschickt werden',

  // bezpečnost
  'bezp.titulek': 'Sicherheit',
  'bezp.sifrovaniZapnuto': (p) => `Die Nachrichtenverschlüsselung ist an${p.odemceno ? ' und entsperrt' : ' (in diesem Tab gesperrt)'}.`,
  'bezp.sifrovaniVypnuto': 'Du hast die Nachrichtenverschlüsselung noch nicht eingeschaltet.',
  'bezp.sifrovaniKde': 'Du schaltest sie auf der Seite Nachrichten ein und entsperrst sie dort.',
  'bezp.sifrovaniKdeVypnute': 'Du kannst sie auf der Seite Nachrichten in jeder Unterhaltung einschalten.',
  'bezp.zmenaHesla': 'Passwort ändern',
  'bezp.zmenaHeslaSifrovani': 'Die Verschlüsselung ist an, deshalb wird beim Passwortwechsel auch der Schlüssel deiner Nachrichten neu verpackt. '
      + 'Darum braucht es das aktuelle Passwort — ohne es ließe sich der Schlüssel nicht öffnen und du verlörst deine Nachrichten.',
  'bezp.stavajiciHeslo': 'Aktuelles Passwort',
  'bezp.noveHeslo': 'Neues Passwort',
  'bezp.noveHesloZnovu': 'Neues Passwort wiederholen',
  'bezp.pozadavky': 'Mindestens 8 Zeichen, Groß- und Kleinbuchstaben, eine Ziffer und ein Sonderzeichen.',
  'bezp.zmenitHeslo': 'Passwort ändern',
  'bezp.menim': 'Wird geändert…',
  'bezp.hesloNeshoda': 'Die neuen Passwörter stimmen nicht überein.',
  'bezp.vyplnObe': 'Füll bitte beide Passwörter aus.',
  'bezp.stareNesedi': 'Das aktuelle Passwort stimmt nicht — der Schlüssel deiner Nachrichten ginge verloren, deshalb wurde nichts geändert.',
  'bezp.zmenenoSKlicem': 'Passwort geändert. Der Schlüssel deiner Nachrichten wurde neu verpackt, alte Nachrichten bleiben lesbar.',
  'bezp.zmeneno': 'Passwort geändert.',
  'bezp.zmenaChyba': 'Das Passwort konnte nicht geändert werden.',
  'bezp.nepamatujes': 'Erinnerst du dich nicht an das Passwort für den Schlüssel?',
  'bezp.zahoditPopis': 'Du kannst den Schlüssel verwerfen und neu anfangen. Die bisher verschlüsselten Nachrichten sind dann für immer weg '
      + '— niemand kann sie lesen, wir auch nicht. Genau deshalb ist es sicher.',
  'bezp.zahodit': 'Schlüssel verwerfen und neu anfangen',
  'bezp.zahoditPotvrzeni': 'Die Schlüssel wirklich verwerfen?\n\nAlle bisher verschlüsselten Nachrichten sind dann für immer weg '
      + '— niemand kann sie lesen, wir auch nicht. Mach das nur, wenn du dich an das Passwort nicht erinnerst, '
      + 'das du beim Einschalten der Verschlüsselung benutzt hast.',
  'bezp.klicSmazan': 'Schlüssel gelöscht. Lade die Seite bitte neu.',
  'bezp.nepovedlo': 'Das hat nicht geklappt.',
  'bezp.prohlizecNeumi': 'Dieser Browser unterstützt die Verschlüsselung nicht, die Bloom benutzt.',

  'profil.mujProfil': 'Mein Profil',
  'profil.specializacePriklad': 'z. B. Psychologie, Sexualmedizin, Recht…',
  'profil.zpravaPriklad': 'Zum Beispiel ein Link auf deine Zulassung oder die Website deiner Praxis…',
  'profil.overeniUvod': 'Möchtest du auf Bloom eine geprüfte Fachperson oder Jurist:in sein? Schick eine Prüfungsanfrage. '
      + 'Dein Profil muss zu deinem echten Beruf passen.',

  'profil.oborPriklad': 'z. B. plastische Chirurgie, Familienrecht…',
  'profil.nepovinnyText': 'Zusätzliche Anmerkung, optional…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Zwei-Faktor-Anmeldung',
  'dvf.zapnuto': (p) => `An. Dir bleiben ${p.pocet} Ersatzcodes.`,
  'dvf.vypnuto': 'Zusätzlich zum Passwort gibst du einen sechsstelligen Code aus einer App auf deinem Handy ein.',
  'dvf.chraniA': 'Sie schützt',
  'dvf.chraniPrihlaseni': 'die Anmeldung',
  'dvf.chraniB': ': wer dein Passwort kennt, aber dein Handy nicht hat, kommt nicht rein.',
  'dvf.nechrani': 'Sie schützt keine verschlüsselten Nachrichten',
  'dvf.nechraniPopis': ' — die werden mit deinem Passwort in deinem eigenen Browser geöffnet, ohne den Server.',
  'dvf.ulozKody': 'Bewahre diese zehn Ersatzcodes auf',
  'dvf.ulozKodyPopis1': 'Jeder funktioniert einmal, und sie sind der einzige Weg hinein, wenn du dein Handy verlierst.',
  'dvf.znovuNeukaze': 'Niemand zeigt sie dir noch einmal',
  'dvf.ulozKodyPopis2': ' — wir speichern nur ihren Hash.',
  'dvf.zkopirovat': 'Kopieren',
  'dvf.ulozilaJsem': 'Habe ich gespeichert',
  'dvf.zkopirovano': 'Kopiert.',
  'dvf.kopieChyba': 'Kopieren hat nicht geklappt, schreib sie bitte per Hand ab.',
  'dvf.zapnout': 'Zwei-Faktor-Anmeldung einschalten',
  'dvf.pripravuji': 'Wird vorbereitet…',
  'dvf.nactiKod': 'Scanne diesen Code in einer Authenticator-App — zum Beispiel Google Authenticator, Authy, 1Password oder Aegis.',
  'dvf.qrNejde': 'QR-Code lässt sich nicht scannen?',
  'dvf.zadejRucne': 'Gib diesen Schlüssel per Hand in der App ein:',
  'dvf.opisKod': 'Übertrage den Code, den die App zeigt',
  'dvf.zapnoutKratce': 'Einschalten',
  'dvf.overuji': 'Wird geprüft…',
  'dvf.noveKody': 'Neue Ersatzcodes',
  'dvf.vypnout': 'Ausschalten',
  'dvf.noveKodyPopis': 'Der neue Satz ersetzt den alten — deine bisherigen Ersatzcodes funktionieren dann nicht mehr.',
  'dvf.kodZAplikace': 'Code aus der App',
  'dvf.vygenerovat': 'Erzeugen',
  'dvf.vypnutiPopis': 'Zum Ausschalten braucht es dein Passwort und einen gültigen Code. Beides mit Absicht: sonst könnte jede Person mit Zugang zu einem offenen Browser es entfernen.',
  'dvf.kodNeboZalozni': 'Code aus der App oder ein Ersatzcode',
  'dvf.vypinam': 'Wird ausgeschaltet…',
  'dvf.vypnoutCele': 'Zwei-Faktor-Anmeldung ausschalten',
  'dvf.vypnuto2': 'Zwei-Faktor-Anmeldung ausgeschaltet.',
  'dvf.kodNesedi': 'Dieser Code stimmt nicht.',
  'dvf.nepovedlo': 'Das hat nicht geklappt.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Profil aktualisiert.',
  'pf.chyba': 'Das Profil konnte nicht aktualisiert werden',
  'pf.fotkaNahrana': 'Foto hochgeladen.',
  'pf.fotkaChyba': 'Das Bild konnte nicht hochgeladen werden',
  'pf.fotkaVelka': 'Das Bild ist zu groß (max. 5 MB)',
  'pf.oznameniUlozeno': 'Benachrichtigungen gespeichert.',
  'pf.oznameniChyba': 'Die Einstellungen konnten nicht gespeichert werden',
  'pf.zruseno': 'Dein Profil wurde gelöscht',
  'pf.zruseniChyba': 'Das Profil konnte nicht gelöscht werden',
  'pf.zruseniPotvrzeni': 'Willst du dein Profil wirklich löschen? Das lässt sich nicht rückgängig machen und alle deine Daten werden gelöscht.',
  'pf.urlFacebook': 'Die Facebook-Adresse muss mit https:// anfangen',
  'pf.urlInstagram': 'Die Instagram-Adresse muss mit https:// anfangen',
  'pf.urlLinkedin': 'Die LinkedIn-Adresse muss mit https:// anfangen',
  'pf.ukladam': 'Wird gespeichert…',
  'pf.ulozitOznameni': 'Benachrichtigungen speichern',
  'pf.oznameniZpravy': 'Private Nachrichten',
  'pf.oznameniAdmin': 'Neue Nachricht von der Administration',
  'pf.oznameniUzivatel': 'Neue Nachricht von einer anderen Person',
  'pf.oznameniPodpora': 'Neuer Beitrag in Gegenseitige Hilfe',
  'pf.oznameniNabidky': 'Angebote und Gesuche',

  // odznaky
  'pf.odznakAdmin': 'Administration',
  'pf.odznakPravnik': 'Jurist:in',
  'pf.odznakSpecialista': 'Geprüfte Fachperson',
  'pf.odznakClen': 'Geprüftes Mitglied der Community',
  'pf.odznakPomocnik': 'Aktive Hilfe',
  'pf.odznakDuveryhodny': 'Vertrauenswürdig',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Foto zur Galerie hinzugefügt.',
  'gal.smazano': 'Foto gelöscht',
  'gal.hesloKratke': 'Das Galerie-Passwort muss mindestens 4 Zeichen haben',
  'gal.nahraniChyba': 'Das Foto konnte nicht hochgeladen werden',
  'gal.mazaniChyba': 'Das Foto konnte nicht gelöscht werden',
  'gal.souborVelky': 'Die Datei ist zu groß (max. 5 MB)',
  'gal.ulozitNastaveni': 'Einstellungen speichern',
  'gal.hesloPopis': 'Wer die Galerie ansehen will, muss dieses Passwort eingeben.',
  'gal.pridat': 'Foto oder Video hinzufügen',
  'gal.prazdna': 'Noch keine Fotos in der Galerie',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Wo stehe ich gerade?',
  'cesta.popis': 'Teile deine Transitionsphase, wenn du magst — oder behalte sie für dich.',
  'cesta.soukroma': 'Deine Phase ist privat',
  'cesta.viditelna': 'Deine Phase ist für andere sichtbar',
  'cesta.jenTy': 'Nur du siehst deine Phase',
  'cesta.mohouNajit': 'Andere können dich über „Menschen in einer ähnlichen Phase finden“ finden',
  'cesta.poznamka': 'Persönliche Notiz',
  'cesta.volitelna': '(optional)',
  'cesta.poznamkaPriklad': 'Was du teilen oder dir merken willst…',
  'cesta.najitPodobne': 'Menschen in einer ähnlichen Phase finden',
  'cesta.hledam': 'Wird gesucht…',
  'cesta.ulozit': 'Meinen Weg speichern',
  'cesta.ulozeno': 'Dein Weg wurde gespeichert.',
  'cesta.vyberteFazi': 'Wähl bitte eine Phase',
  'cesta.chyba': 'Speichern hat nicht geklappt',

  'pf.socialniSite': 'Soziale Netzwerke',
  'pf.avatarFoto': 'Avatar / Profilfoto',
  'pf.nahratProfilni': 'Profilfoto hochladen',
  'pf.zrusitProfil': 'Profil löschen',
  'pf.nastaveniOznameni': 'Benachrichtigungen',
  'pf.nastaveniOznameniPopis': 'Wähl aus, worüber du Bescheid bekommen willst.',
  'gal.overEmail': 'Um Fotos hochzuladen, bestätige zuerst deine E-Mail.',
  'cesta.coMeCeka': 'Was mich erwartet',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Nachrichten',
  'zpr.hledatUzivatele': 'Person suchen…',
  'zpr.zadneKonverzace': 'Noch keine Unterhaltungen',
  'zpr.vyhledejteVyse': 'Such oben nach einer Person',
  'zpr.vyberteKonverzaci': 'Wähl eine Unterhaltung oder such jemanden',
  'zpr.napisteZpravu': 'Schreib eine Nachricht…',
  'zpr.nahravam': 'Aufnahme läuft…',
  'zpr.prilozitObrazek': 'Bild anhängen',
  'zpr.hlasovaZprava': 'Sprachnachricht',
  'zpr.zastavitNahravani': 'Aufnahme stoppen',
  'zpr.obrazek': 'Bild',
  'zpr.overteEmail': 'Um Nachrichten zu schicken, bestätige deine E-Mail.',
  'zpr.profil': 'Profil',

  // šifrování
  'zpr.sifrovanaZprava': 'Verschlüsselte Nachricht',
  'zpr.odemkniNahore': 'Verschlüsselte Nachricht — entsperre deine Nachrichten oben.',
  'zpr.nelzeOtevrit': 'Diese verschlüsselte Nachricht ließ sich nicht öffnen.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Person nicht gefunden',
  'zpr.prijemceNenalezen': 'Empfangende Person nicht gefunden',
  'zpr.prihlasteZnovu': 'Melde dich bitte neu an (deine Sitzung ist abgelaufen)',
  'zpr.serverNedostupny': 'Der Server ist nicht erreichbar. Prüf, ob das Backend läuft.',
  'zpr.chybaOdeslani': 'Senden hat nicht geklappt',
  'zpr.souborVelky': 'Die Datei ist zu groß (max. 5 MB)',
  'zpr.formatNepodporovan': 'Dieser Dateityp wird nicht unterstützt',
  'zpr.mediaOdeslano': 'Datei geschickt',
  'zpr.mikrofon': 'Das Mikrofon ist nicht verfügbar',
  'zpr.hlasovkaOdeslana': 'Sprachnachricht geschickt',
  'zpr.hlasovkaChyba': (p) => `Die Sprachnachricht ließ sich nicht schicken: ${p.detail}`,
  'zpr.smazano': 'Unterhaltung gelöscht',
  'zpr.smazaniChyba': 'Die Unterhaltung konnte nicht gelöscht werden',
  'zpr.smazaniPotvrzeni': 'Sie verschwindet aus deiner Liste, samt Anhängen. Die andere Person behält ihre Kopie — '
      + 'vom Server ist die Nachricht erst ganz weg, wenn ihr sie beide löscht.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Gib bitte dein Passwort ein.',
  'sif.zapnuto': 'Die Verschlüsselung ist an.',
  'sif.odemceno': 'Deine Nachrichten sind entsperrt.',
  'sif.hesloNesedi': 'Dieses Passwort stimmt nicht.',
  'sif.prohlizecNeumi': 'Dieser Browser unterstützt die Verschlüsselung nicht, die Bloom benutzt. Du kannst trotzdem schreiben, '
      + 'aber die Nachrichten sind dann nicht Ende zu Ende verschlüsselt.',
  'sif.noveJsouSifrovane': 'Neue Nachrichten sind verschlüsselt. Nur du hast den Schlüssel — der Server kann sie nicht lesen.',
  'sif.odemkniZpravy': 'Entsperre deine Nachrichten',
  'sif.odemkniPopis': 'Der Schlüssel lebt nur im Speicher dieses Tabs, nach einem Neuladen brauchst du das Passwort also wieder. '
      + 'Wir können ihn nirgends aufbewahren — dann wäre es keine Verschlüsselung mehr, die nur du kontrollierst.',
  'sif.zapniSifrovani': 'Nachrichtenverschlüsselung einschalten',
  'sif.zapniPopis': 'Neue Nachrichten werden direkt hier auf deinem Gerät verschlüsselt. Der Server bekommt nur unlesbare Zeichen '
      + 'und kann sie nicht lesen — selbst wenn ein Gericht danach fragte.',
  'sif.pozorA': 'Achtung: der Schlüssel wird mit deinem Passwort geöffnet.',
  'sif.pozorTucne': 'Wenn du es vergisst, kann niemand deine verschlüsselten Nachrichten lesen',
  'sif.pozorB': ' — wir auch nicht. Genau darum geht es, aber du brauchst einen Ort, wo du es aufbewahrst.',
  'sif.mobilA': 'Das Einschalten ändert auch die Anmeldung: dein Passwort erreicht den Server gar nicht mehr, nur sein Hash wird geschickt.',
  'sif.mobilTucne': 'Die ältere Bloom-Handy-App kann sich dann bei diesem Konto nicht mehr anmelden',
  'sif.mobilB': ', bis wir sie aktualisieren. Im Web funktioniert alles weiter.',
  'sif.zapnoutSifrovani': 'Verschlüsselung einschalten',
  'sif.odemknout': 'Entsperren',
  'sif.tvojeHeslo': 'Dein Bloom-Passwort',
  'sif.prilohaZamcena': 'Verschlüsselter Anhang — entsperre deine Nachrichten oben.',
  'sif.prilohaChyba': 'Der Anhang ließ sich nicht öffnen.',
  'sif.priloha': 'Anhang der Nachricht',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Dein Ort',
  'okoli.nastavtePolohu': 'Sag, wo du bist, um passende Ergebnisse zu bekommen',
  'okoli.vyberteVyse': 'Wähl oben einen Ort, um Angebote und Fachpersonen in deiner Nähe zu sehen',
  'okoli.zadniOdbornici': 'In dieser Gegend sind noch keine Fachpersonen eingetragen',
  'okoli.zadneNabidky': 'In dieser Gegend gibt es noch keine Angebote',
  'okoli.zadniClenove': 'In dieser Gegend ist noch niemand aus der Community',
  'okoli.vytvoritNabidku': 'Angebot erstellen',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Suche:',
  'hled.vysledkyPro': 'Suchergebnisse für:',
  'hled.nicPro': 'Wir haben nichts gefunden für:',
  'hled.nicZkuste': 'Wir haben nichts gefunden. Versuch ein anderes Wort.',
  'hled.zkratte': 'Versuch einen kürzeren Ausdruck oder ein anderes Stichwort.',
  'hled.zadejte': 'Schreib, was du suchst, und drück Enter',
  'hled.priklady': 'Zum Beispiel: FFS, Hormone, Name, Ärztin, Ausweis, Operation…',
  'hled.uzivatele': 'Personen',
  'hled.odbornici': 'Trans-freundliche Fachpersonen',
  'hled.clanky': 'Rechtliche Hilfe – Artikel',
  'hled.otazky': 'Fragen der Community',
  'hled.nabidky': 'Hilfsangebote',
  'hled.prispevky': 'Beiträge',
  'hled.recenze': 'Bewertungen von Fachpersonen',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Person nicht gefunden',
  'up.oMne': 'Über',
  'up.clenOd': 'Bei Bloom seit',
  'up.odznakSpravce': 'Administration',
  'up.odznakPravnik': 'Jurist:in',
  'up.odznakOdbornik': 'Geprüfte Fachperson',
  'up.odznakPravnikOvereny': 'Geprüfte:r Jurist:in',
  'up.odznakClen': 'Geprüftes Mitglied',
  'up.odznakPomocnik': 'Aktive Hilfe',
  'up.odznakDuveryhodny': 'Vertrauenswürdig',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Zurück zu Bloom',
  'kom.oProjektu': 'Bloom ist als sicherer Community-Raum für trans Menschen in Tschechien entstanden — ein Ort, '
      + 'um Erfahrungen zu teilen, Unterstützung zu finden, Fachpersonen zu erreichen und andere kennenzulernen. '
      + 'Das Projekt trägt die Community ehrenamtlich. Es geht um Diskretion, Privatsphäre und gegenseitige Hilfe.',
  'kom.kontaktText': 'Fragen oder brauchst du Hilfe? Melde dich. Wir versuchen, so schnell wie möglich zu antworten.',
  'kom.respekt': 'Wir respektieren einander',
  'kom.respektPopis': 'Wir sprechen alle mit dem Namen und den Pronomen an, die sie benutzen. Wir respektieren verschiedene Wege und Erfahrungen — '
      + 'es gibt keine richtige oder falsche Art, trans zu sein.',
  'kom.soukromi': 'Wir schützen die Privatsphäre der anderen',
  'kom.soukromiPopis': 'Was in Bloom geteilt wird, bleibt in Bloom. Teile keine Informationen über andere Mitglieder ohne '
      + 'deren Einverständnis. Wir respektieren Anonymität.',
  'kom.pomahame': 'Wir helfen einander',
  'kom.pomahamePopis': 'Bei Bloom geht es um gegenseitige Unterstützung. Wir teilen Erfahrungen, helfen einander und bauen einen sicheren Raum '
      + 'für alle, die Anschluss oder Informationen suchen.',
  'kom.obtezovani': 'Belästigung dulden wir nicht',
  'kom.obtezovaniPopis': 'Belästigung, Mobbing oder feindselige Kommentare haben in Bloom keinen Platz. Wenn du dich unwohl fühlst, '
      + 'schreib der Administration.',
  'kom.spam': 'Kein Spam und keine Werbung',
  'kom.spamPopis': 'Bloom ist kein Marktplatz. Poste keine ungefragte Werbung und keine kommerziellen Inhalte. '
      + 'Angebote und Gesuche gehören in Gegenseitige Hilfe.',
  'kom.prostor': 'Ein Raum für jede Phase',
  'kom.prostorPopis': 'Du bist nicht allein, an welchem Punkt deines Weges du auch stehst. Willkommen sind Menschen, die über eine '
      + 'Transition nachdenken, die mittendrin sind und die sie hinter sich haben — und wir nehmen jeden Weg, wie er ist.',
  'kom.dataPopis': 'Bloom sammelt nur die Daten, die die Plattform zum Funktionieren braucht: deine E-Mail, deinen Nickname und das Profil, '
      + 'das du selbst anlegst.',
  'kom.dataTretiStrany': 'Deine Daten werden nicht an Dritte weitergegeben. Die Plattform benutzt keine Tracking-Technologie und keine Werbenetzwerke.',
  'kom.dataSmazani': 'Du hast das Recht, die Löschung deines Kontos und aller damit verbundenen Daten zu verlangen. Wende dich an die Administration.',

  'okoli.podtitulek': 'Finde Mitglieder der Community, Angebote und Fachpersonen in deiner Nähe',
  'okoli.cleneVOkoli': (p) => `Mitglieder der Community in der Nähe von ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Hilfsangebote in der Nähe von ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Fachpersonen in der Nähe von ${p.misto}`,
  'hled.zobrazitVice': 'Mehr anzeigen',
  'kom.titulek': 'Regeln der Community',
  'kom.podtitulek': 'Ein sicherer Raum für alle',
  'kom.jakNahlasit': 'Wie du ein Problem meldest',
  'kom.jakNahlasitPopis': 'Wenn du auf unangemessenes Verhalten stößt, hast du zwei Möglichkeiten: den Knopf „Person melden“ '
      + 'auf ihrem Profil, oder du schreibst der Administration.',
  'kom.duverne': 'Deine Meldung ist vertraulich.',
  'kom.ochranaSoukromi': 'Privatsphäre',
  'obecne.zpetKratce': 'Zurück',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Bisher teilt niemand sonst aus der Community diese Phase öffentlich.',
  'cesta.poznamkaFazePriklad': 'Was du zu dieser Phase teilen oder dir merken willst…',
  'pruvodce.fazeNenalezena': 'Phase nicht gefunden',
  'pruvodce.pripravujeme': 'Diesen Teil bereiten wir noch vor.',
  'pruvodce.krokyJenTy': 'Die Schritte, die du abhakst, siehst nur du.',
  'pruvodce.nastavitFazi': 'Als meine aktuelle Phase festlegen',
  'pruvodce.fazeNastavena': 'Als deine aktuelle Phase festgelegt',
  'pruvodce.chyba': 'Speichern hat nicht geklappt, versuch es noch mal',
  'pruvodce.kroku': 'Schritte',
  'pruvodce.odborniku': (p) => `${p.pocet === 1 ? 'Fachperson' : 'Fachpersonen'} für diese Phase`,
  'pruvodce.pribehu': (p) => `${p.pocet === 1 ? 'Erfahrungsbericht' : 'Erfahrungsberichte'} von Menschen in dieser Phase`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Passwort zurücksetzen',
  'reset.popis': 'Gib ein neues Passwort für dein Bloom-Konto ein.',
  'reset.noveHeslo': 'Neues Passwort',
  'reset.noveHesloPriklad': 'Neues Passwort eingeben',
  'reset.potvrdit': 'Neues Passwort bestätigen',
  'reset.nastavit': 'Neues Passwort speichern',
  'reset.ukladam': 'Wird gespeichert…',
  'reset.hotovo': 'Dein Passwort wurde geändert. Du kannst dich jetzt anmelden.',
  'reset.neplatnyOdkaz': 'Dieser Link zum Zurücksetzen ist nicht gültig.',
  'reset.odkazVyprsel': 'Der Link ist abgelaufen oder ungültig. Fordere einen neuen an.',
  'reset.chyba': 'Das Passwort konnte nicht zurückgesetzt werden.',
  'reset.neshoda': 'Die Passwörter stimmen nicht überein.',
  'reset.ztratiPristup': 'verliert den Zugang',

  'cesta.volitelne': 'Das ist ganz freiwillig. Teile deine Transitionsphase, wenn du magst — oder behalte sie für dich. '
      + 'Du kannst auch Menschen an einem ähnlichen Punkt ihres Weges finden.',
  'cesta.hledatVeFazi': 'Menschen in dieser Phase finden:',
  'cesta.jenVerejne': '(nur wer sie öffentlich teilt)',
  'pruvodce.zpetNaCestu': 'Zurück zu Mein Weg',
  'pruvodce.tadyJsi': 'Hier stehst du gerade',
  'reset.prejitNaPrihlaseni': 'Zur Anmeldung',
  'reset.sifrovaniVarovani': 'Falls du die Nachrichtenverschlüsselung an hast: mit dem Zurücksetzen des Passworts kommst du an deine alten '
      + 'verschlüsselten Nachrichten nicht mehr heran. Ihr Schlüssel wird mit dem ursprünglichen Passwort geöffnet, und das kennt hier niemand, '
      + 'er lässt sich also nicht neu verpacken. Neue Nachrichten können weiter verschlüsselt werden, die alten nicht mehr gelesen — auch von uns nicht.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Anmelden',
  'uvod.vytvoritUcet': 'Konto anlegen',
  'uvod.uzMamUcet': 'Ich habe schon ein Konto',
  'uvod.nadpis': 'Ein sicherer Raum für die trans Community',
  'uvod.podnadpis': 'Bloom ist ein privater Ort, an dem du offen sprechen, trans-freundliche Fachpersonen finden '
      + 'und deine Transition unter Menschen erleben kannst, die wissen, wie das ist.',
  'uvod.zdarma': 'Die Registrierung ist kostenlos. Die Inhalte von Bloom öffnen sich erst nach der Anmeldung.',
  'uvod.kCemuJe': 'Wofür Bloom da ist',
  'uvod.kCemuJe1': 'Informationen über Transition in Tschechien zu suchen heißt meistens, sich durch verstreute '
      + 'Foren, veraltete Artikel und Links zu klicken, bei denen man nicht weiß, wem man trauen kann. Und viele Fragen '
      + 'beantwortet ohnehin am besten jemand, der das selbst durchgemacht hat.',
  'uvod.kCemuJe2': 'Bloom bringt das alles an einen Ort: Fachpersonen, mit denen die Community gute Erfahrungen hat, einen Wegweiser '
      + 'durch die Phasen der Transition, rechtliche Hilfe und vor allem Menschen, denen man schreiben kann.',
  'uvod.kCemuJe3': 'Und weil es um Dinge geht, die niemand dem ganzen Internet erzählen will, ist Bloom von '
      + 'Anfang an so gebaut, dass von außen überhaupt nichts zu sehen ist.',
  'uvod.coNajdes': 'Was du in Bloom findest',
  'uvod.coNajdesPopis': 'Acht Teile, die aufeinander aufbauen — von praktischer Hilfe bis zu geteilten Erfahrungen.',
  'uvod.soukromiZaklad': 'Privatsphäre ist kein Zusatz, sondern die Grundlage',
  'uvod.jakZabezpeceny': 'Wie Bloom abgesichert ist',
  'uvod.zabezpeceniPopis': 'Daten der Mitglieder werden nirgends verkauft oder ausgewertet. In Bloom läuft kein Werbe- '
      + 'und kein Analyse-Tracking — kein fremdes Skript erfährt etwas über dich.',
  'uvod.coNeumi': 'Was Bloom nicht kann',
  'uvod.metadataTucne': 'wer wem wann geschrieben hat',
  'uvod.coNeumiA': 'Der Server weiß immer,',
  'uvod.coNeumiB': ' — ohne das könnte er die Nachricht nicht zustellen. Diese Metadaten verbirgt auch Ende-zu-Ende-Verschlüsselung '
      + 'nicht, und Signal kann das auch nicht. Profile lassen sich nicht verschlüsseln, weil der Server sie anderen zeigen '
      + 'muss. Und weil Bloom eine Web-App ist, lädt es seinen Verschlüsselungscode bei jedem Öffnen von unserem Server '
      + '— wer den Server übernähme, könnte theoretisch einen veränderten unterschieben. '
      + 'Dagegen hilft nur eine signierte App aus einem Store.',
  'uvod.pridejSe': 'Komm dazu',
  'uvod.pridejSePopis': 'Ein Nickname und eine E-Mail reichen — deinen amtlichen Namen musst du nirgends angeben. Was du über '
      + 'dich schreibst, bleibt deine Sache, und du kannst es jederzeit ändern oder löschen.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Biete Hilfe an oder bitte darum — von der Begleitung zur Ärztin über geliehene Kleidung bis zu '
      + '„ich muss mit jemandem reden“.',
  'uvod.karta.odbornici': 'Sexualmedizin, Endokrinologie, Chirurgie, Psychotherapie und auch Friseur:innen. Mit Karte, Kontakten und den Erfahrungen anderer.',
  'uvod.karta.pravo': 'Namensänderung, Papiere, Arbeit, Schule. Es antworten Menschen, die sich damit auskennen.',
  'uvod.karta.pruvodce': 'Was dich in den einzelnen Schritten erwartet — von den ersten Fragen bis zu Operationen. Mit Links zu geprüften Quellen und Fachpersonen.',
  'uvod.karta.zpravy': 'Schreib jeder Person aus der Community. Nachrichten und Anhänge liegen verschlüsselt auf dem Server.',
  'uvod.karta.zkusenosti': 'Echte Geschichten von Menschen, die das durchgemacht haben. Ohne Zensur und ohne Beschönigung.',
  'uvod.karta.aktuality': 'Was rund um trans Themen in Tschechien passiert — Gesetzesänderungen, Veranstaltungen, Neues aus der Community.',
  'uvod.karta.okoli': 'Wer in deiner Nähe ist. Damit du weißt, dass du nicht allein bist, auch nicht in einer kleineren Stadt.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Von außen ist überhaupt nichts zu sehen',
  'uvod.bezp.zvencinicText': 'Profile, Geschichten, Fotos, Angebote und Bilder in Beiträgen brauchen eine Anmeldung. Ohne Konto gibt der '
      + 'Server keine Angaben über Mitglieder heraus — auch Suchmaschinen nicht.',
  'uvod.bezp.hesla': 'Niemand kennt dein Passwort',
  'uvod.bezp.heslaText': 'Gespeichert wird nur ein bcrypt-Hash, aus dem sich das ursprüngliche Passwort nicht berechnen lässt. Auch die '
      + 'Administration sieht dein Passwort nicht und kann es dir nicht schicken — sie kann dich nur ein neues setzen lassen.',
  'uvod.bezp.sifrovani': 'Nachrichten verschlüsselt von dir zu ihr',
  'uvod.bezp.sifrovaniText': 'Wenn du die Ende-zu-Ende-Verschlüsselung einschaltest, werden Text und Anhänge in deinem eigenen Browser verschlüsselt. '
      + 'Der Schlüssel wird mit deinem Passwort geöffnet und verlässt dein Gerät nie — der Server bekommt nur '
      + 'unlesbare Zeichen und kann sie nicht lesen, selbst wenn ein Gericht danach fragte. Ohne Verschlüsselung sind Nachrichten wenigstens '
      + 'auf der Serverplatte verschlüsselt.',
  'uvod.bezp.kontakty': 'Deine Kontaktdaten bleiben bei dir',
  'uvod.bezp.kontaktyText': 'E-Mail und Telefon werden anderen Mitgliedern nie zurückgegeben. Deine Transitionsphase ist privat, bis '
      + 'du sie selbst veröffentlichst — und die Schritte, die du im Wegweiser abhakst, siehst nur du.',
  'uvod.bezp.smazane': 'Gelöscht heißt wirklich gelöscht',
  'uvod.bezp.smazaneText': 'Du kannst eine Unterhaltung jederzeit löschen. Wenn beide Seiten sie löschen, verschwindet sie dauerhaft vom Server, '
      + 'samt Anhängen.',
  'uvod.bezp.server': 'Eigener Server in Europa',
  'uvod.bezp.serverText': 'Bloom läuft auf einem eigenen Server in der Europäischen Union, ausschließlich über HTTPS. Die Datenbank ist aus dem '
      + 'Internet nicht erreichbar. Backups gehen verschlüsselt auf einen anderen Speicher und ihre Wiederherstellung ist getestet.',

  'uvod.karta.pruvodceNazev': 'Wegweiser durch die Transition',
  'uvod.karta.zpravyNazev': 'Private Nachrichten',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Biete an, was du kannst, und bekomm Hilfe von anderen aus der Community',
  'pod.vse': 'Alles',
  'pod.nabidky': 'Angebote',
  'pod.poptavky': 'Gesuche',
  'pod.nabidka': 'Angebot',
  'pod.poptavka': 'Gesuch',
  'pod.celaCR': 'Ganz Tschechien',
  'pod.celySvet': 'Die ganze Welt',
  'pod.cesko': 'Tschechien',
  'pod.svet': 'Welt',
  'pod.vsechnyTypy': 'Alle Kategorien',
  'pod.moje': (p) => `Meine (${p.pocet})`,
  'pod.pridat': 'Hinzufügen',
  'pod.overEmail': 'Bestätige deine E-Mail, um ein Angebot einzustellen',
  'pod.novaPoptavka': 'Neues Gesuch',
  'pod.novaNabidka': 'Neues Angebot',
  'pod.popisPoptavky': 'Schreib, was du suchst und was du im Tausch anbietest.',
  'pod.popisNabidky': 'Biete anderen aus der Community an, was du kannst.',
  'pod.typPrispevku': 'Art des Beitrags',
  'pod.volitelne': '(optional)',
  'pod.coNabizim': 'Was ich anbiete',
  'pod.coNabizimP': 'Was ich anbiete *',
  'pod.coHledamP': 'Was ich suche *',
  'pod.coHledamVymenou': 'Was ich im Tausch suche',
  'pod.priklOffer': 'z. B. Kochen, Haare, Übersetzen…',
  'pod.priklNeed': 'z. B. Massage, Fotografie…',
  'pod.poptavkaSeZobrazi': 'Dein Gesuch erscheint im Reiter Gesuche.',
  'pod.nabidkaSeZobrazi': 'Wenn du das ausfüllst, erscheint dein Angebot auch im Reiter Gesuche.',
  'pod.popis': 'Beschreibung',
  'pod.popisPriklad': 'Eine ausführlichere Beschreibung…',
  'pod.oblast': 'Gegend',
  'pod.lokalita': 'Ort',
  'pod.nechciUvadet': 'Möchte ich nicht angeben',
  'pod.kategorie': 'Kategorie',
  'pod.ostatni': 'Sonstiges',
  'pod.pridatPoptavku': 'Gesuch einstellen',
  'pod.pridatNabidku': 'Angebot einstellen',
  'pod.odpovedetNaPrispevek': 'Auf den Beitrag antworten',
  'pod.napisteAutorovi': 'Schreib der Person, die das eingestellt hat, eine private Nachricht.',
  'pod.od': (p) => `Von: ${p.kdo}`,
  'pod.odeslatZpravu': 'Nachricht schicken',
  'pod.konceptOdpovedi': (p) => `Hallo! Dein ${p.co} „${p.nazev}“ interessiert mich. `,
  'pod.konceptPoptavka': 'Gesuch',
  'pod.konceptNabidka': 'Angebot',
  'pod.zadneMoje': 'Du hast noch keine Beiträge',
  'pod.zadneNalezeny': 'Keine Beiträge gefunden',
  'pod.vytvortePrvni': 'Erstell dein erstes Angebot oder Gesuch',
  'pod.zkusteFiltry': 'Versuch, die Filter zu ändern, oder stell einen neuen Beitrag ein',
  'pod.expirovano': 'Abgelaufen',
  'pod.hledam': 'Ich suche',
  'pod.hledamCo': (p) => `Ich suche: ${p.co}`,
  'pod.nabizimCo': (p) => `Ich biete an: ${p.co}`,
  'pod.expirovala': 'Dieses Angebot ist abgelaufen. Wende dich an die Administration, um es zu erneuern.',
  'pod.odpovedet': 'Antworten',
  'pod.upravitPrispevek': 'Beitrag bearbeiten',
  'pod.upravtePrispevek': 'Bearbeite dein Angebot oder Gesuch.',
  'pod.nabizimP': 'Ich biete an *',
  'pod.hledamPotrebuji': 'Ich suche / brauche',
  'pod.coNabizitePriklad': 'Was du anbietest…',
  'pod.coHledatePriklad': 'Was du suchst…',
  'pod.ulozitZmeny': 'Änderungen speichern',
  'pod.vytvorenoPoptavka': 'Gesuch erstellt.',
  'pod.vytvorenoNabidka': 'Angebot erstellt.',
  'pod.chybaVytvorit': 'Der Beitrag konnte nicht erstellt werden',
  'pod.opravduSmazat': 'Dieses Angebot löschen?',
  'pod.smazano': 'Gelöscht',
  'pod.chybaSmazat': 'Löschen hat nicht geklappt',
  'pod.aktualizovano': 'Beitrag aktualisiert.',
  'pod.chybaUlozit': 'Speichern hat nicht geklappt',
  'pod.zpravaOdeslana': 'Nachricht geschickt.',
  'pod.chybaOdeslat': 'Die Nachricht konnte nicht geschickt werden',
  'obecne.hledatPriklad': 'Suchen…',
  'obecne.upravit': 'Bearbeiten',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Finde geprüfte Fachpersonen, die dir auf deinem Weg helfen können',
  'odb.hledatPriklad': 'Nach Name oder Stadt suchen…',
  'odb.vsechnyObory': 'Alle Fachrichtungen',
  'odb.radit': 'Sortieren:',
  'odb.vychozi': 'Standard',
  'odb.nejvyssiHodnoceni': '★ Am besten bewertet',
  'odb.nejnizsiHodnoceni': '★ Am schlechtesten bewertet',
  'odb.zadniNalezeni': 'Keine Fachpersonen gefunden',
  'odb.zkusteFiltry': 'Versuch, die Filter zu ändern',
  'odb.recenzi': (p) => (p.pocet === 1 ? 'Bewertung' : 'Bewertungen'),
  'odb.dostupnyV': 'Verfügbar in:',
  'odb.otevritVMapach': 'In der Karte öffnen',
  'odb.pridatRecenzi': 'Bewertung schreiben',
  'odb.ohodnotte': 'Bewerte deine Erfahrung mit dieser Person.',
  'odb.vaseHodnoceni': 'Deine Bewertung *',
  'odb.popisZkusenosti': 'Beschreib deine Erfahrung',
  'odb.popisteZkusenost': 'Beschreib deine Erfahrung…',
  'odb.odeslatRecenzi': 'Bewertung schicken',
  'odb.recenze': (p) => `Bewertungen (${p.pocet})`,
  'odb.zadneRecenze': 'Noch keine Bewertungen. Sei die erste Person.',
  'odb.vyberteOdbornika': 'Wähl eine Fachperson, um Details und Karte zu sehen',
  'odb.pridatOdbornika': 'Fachperson hinzufügen',
  'odb.pridejteOdbornika': 'Füg der Liste eine neue geprüfte Fachperson hinzu.',
  'odb.navrhnout': 'Fachperson vorschlagen',
  'odb.navrhnetePopis': 'Schlag eine Fachperson zur Freigabe durch die Administration vor.',
  'odb.navrhVysvetleni': 'Dein Vorschlag geht an die Administration. Nach der Freigabe erscheint er in der Liste.',
  'odb.overEmail': 'Bestätige deine E-Mail, um eine Fachperson vorzuschlagen',
  'odb.jmeno': 'Name *',
  'odb.kategorie': 'Kategorie *',
  'odb.popis': 'Beschreibung',
  'odb.popisPriklad': 'Fachgebiet, Erfahrung…',
  'odb.adresa': 'Adresse *',
  'odb.mesto': 'Stadt *',
  'odb.kraj': 'Region',
  'odb.vyber': 'Auswählen',
  'odb.stat': 'Land',
  'odb.cesko': 'Tschechien',
  'odb.telefon': 'Telefon',
  'odb.web': 'Website',
  'odb.odesilam': 'Wird geschickt…',
  'odb.odeslatKeSchvaleni': 'Zur Freigabe schicken',
  'odb.recenzePridana': 'Bewertung hinzugefügt.',
  'odb.chybaRecenze': 'Die Bewertung konnte nicht hinzugefügt werden',
  'odb.odeslanKeSchvaleni': 'Der Vorschlag wurde zur Freigabe geschickt.',
  'odb.chybaOdeslat': 'Schicken hat nicht geklappt',
  'odb.pridan': 'Fachperson hinzugefügt.',
  'odb.chybaPridat': 'Hinzufügen hat nicht geklappt',
  'odb.polozitOtazku': 'Frage stellen',
  'odb.novaOtazka': 'Neue Frage an die Fachpersonen',
  'odb.naCoSeZeptat': 'Was möchtest du die Fachpersonen fragen?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Informationen und Unterstützung für die trans Community',
  'prav.zpetNaPoradnu': 'Zurück zu Rechtliche Hilfe',
  'prav.clankyAPruvodci': 'Artikel und Leitfäden',
  'prav.pridatClanek': 'Artikel hinzufügen',
  'prav.novyClanek': 'Neuer Artikel',
  'prav.vytvorteClanek': 'Schreib einen neuen Artikel für den rechtlichen Teil.',
  'prav.nazev': 'Titel *',
  'prav.kategorie': 'Kategorie',
  'prav.publikovatIhned': 'Sofort veröffentlichen',
  'prav.publikovano': 'Veröffentlicht',
  'prav.obsah': 'Inhalt *',
  'prav.obsahPriklad': 'Inhalt des Artikels…',
  'prav.zadneClanky': 'Keine Artikel in dieser Kategorie',
  'prav.skryto': 'Versteckt',
  'prav.skryt': 'Verstecken',
  'prav.publikovat': 'Veröffentlichen',
  'prav.upravitClanek': 'Artikel bearbeiten',
  'prav.upravteObsah': 'Bearbeite den Inhalt dieses Artikels.',
  'prav.clanekPridan': 'Artikel hinzugefügt.',
  'prav.chybaPridat': 'Der Artikel konnte nicht hinzugefügt werden',
  'prav.clanekUpraven': 'Artikel aktualisiert.',
  'prav.opravduSmazat': 'Diesen Artikel löschen?',
  'prav.chybaStav': 'Der Status konnte nicht geändert werden',
  'prav.pridatOtazku': 'Frage hinzufügen',
  'prav.novaOtazka': 'Neue Frage',
  'prav.naCoSeZeptat': 'Was möchtest du fragen?',
  'obecne.vse': 'Alles',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Neues aus der trans Welt',
  'akt.prehratVideo': 'Video abspielen',
  'akt.obrazekVClanku': 'Bild im Artikel',
  'akt.clanekNenalezen': 'Artikel nicht gefunden',
  'akt.zpetNaAktuality': 'Zurück zu Aktuelles',
  'akt.autor': (p) => `Von: ${p.kdo}`,
  'akt.osobniPribeh': 'Persönliche Geschichte',
  'akt.upravitClanek': 'Artikel bearbeiten',
  'akt.komentare': (p) => `Kommentare (${p.pocet})`,
  'akt.zadneKomentare': 'Noch keine Kommentare. Sei die erste Person.',
  'akt.pridatKomentar': 'Kommentar schreiben…',
  'akt.proKomentovaniOverte': 'Bestätige deine E-Mail, um zu kommentieren.',
  'akt.profil': 'Profil',
  'akt.prihlasteSeProKomentovani': 'Melde dich an, um zu kommentieren.',
  'akt.upravteObsah': 'Bearbeite den Inhalt dieses Artikels.',
  'akt.nadpisP': 'Überschrift *',
  'akt.nadpis': 'Überschrift',
  'akt.obsahP': 'Inhalt *',
  'akt.textClanku': 'Text des Artikels…',
  'akt.obrazekUrlNeboSoubor': 'Bild (Adresse oder Datei)',
  'akt.videoUrlNeboSoubor': 'Video (Adresse oder Datei)',
  'akt.ukladam': 'Wird gespeichert…',
  'akt.novaAktualita': 'Neuer Beitrag',
  'akt.sdiletPribeh': 'Geschichte teilen',
  'akt.vytvoritAktualitu': 'Beitrag schreiben',
  'akt.sdiletZkusenost': 'Erfahrung teilen',
  'akt.napisteAktualitu': 'Schreib einen neuen Beitrag für die Community.',
  'akt.podelteSe': 'Teile deine Erfahrung mit der Community.',
  'akt.obrazek': 'Bild',
  'akt.nahratObrazek': 'Bild hochladen…',
  'akt.nahratVideo': 'Video hochladen…',
  'akt.neboUrl': 'oder eine Adresse:',
  'akt.textAktuality': 'Text des Beitrags…',
  'akt.sdilejtePribeh': 'Teile deine Geschichte oder Erfahrung mit der Community…',
  'akt.nahravam': 'Wird hochgeladen…',
  'akt.publikovat': 'Veröffentlichen',
  'akt.zkusenostiTucne': 'Persönliche Erfahrungen aus der Community.',
  'akt.zkusenostiPopis': 'Dieser Bereich ist zum Teilen von Lebenserfahrungen und Geschichten da. Beiträge können Text, Bilder oder Video enthalten.',
  'akt.sdiletSvujPribeh': 'Meine Geschichte teilen',
  'akt.zadneAktuality': 'Keine Neuigkeiten',
  'akt.zadneVKategorii': 'In dieser Kategorie gibt es noch nichts',
  'akt.publikovan': 'Beitrag veröffentlicht.',
  'akt.chybaPublikovat': 'Veröffentlichen hat nicht geklappt',
  'akt.opravduSmazat': 'Diesen Beitrag löschen?',
  'akt.chyba': 'Etwas ist schiefgelaufen',
  'akt.chybaKomentar': 'Der Kommentar konnte nicht hinzugefügt werden',
  'akt.chybaSmazatKomentar': 'Der Kommentar konnte nicht gelöscht werden',
  'akt.aktualizovan': 'Beitrag aktualisiert.',
  'obecne.smazat': 'Löschen',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Ich denke über eine Transition nach',
  'faze.thinking.popis': 'Ich finde heraus, wer ich bin und welcher Weg meiner ist.',
  'faze.research': 'Ich suche Informationen',
  'faze.research.popis': 'Ich lese, frage, suche Quellen und Community.',
  'faze.therapist': 'Erster Termin in Therapie',
  'faze.therapist.popis': 'Ich spreche mit einer Fachperson über meinen Weg.',
  'faze.hormones': 'Hormontherapie',
  'faze.hormones.popis': 'Ich beginne oder setze die Hormontherapie fort.',
  'faze.documents': 'Änderung der Papiere',
  'faze.documents.popis': 'Ich arbeite an der amtlichen Änderung von Name oder Geschlechtseintrag.',
  'faze.cosmetic': 'Aussehen und Pflege',
  'faze.cosmetic.popis': 'Ich arbeite an meinem Aussehen – Haare, Make-up, Stil.',
  'faze.surgery-thinking': 'Ich denke über Operationen nach',
  'faze.surgery-thinking.popis': 'Ich wäge die chirurgischen Möglichkeiten ab.',
  'faze.surgery': 'Nach den Operationen',
  'faze.surgery.popis': 'Ich habe eine oder mehrere Operationen hinter mir.',
  'faze.stable': 'Stabile Phase',
  'faze.stable.popis': 'Ich bin da, wo ich sein will, und lebe mein Leben.',
  'faze.individual': 'Mein eigener Weg',
  'faze.individual.popis': 'Mein Weg passt in keine Schublade – und das ist gut so.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Hier werden Geschichten geteilt.',
  'zk.pribehNenalezen': 'Geschichte nicht gefunden',
  'zk.zpetNaPribehy': 'Zurück zu den Geschichten',
  'zk.komunita': 'Die Community',
  'zk.pribeh': 'Geschichte',
  'zk.upravitPribeh': 'Geschichte bearbeiten',
  'zk.upravtePribeh': 'Bearbeite die Geschichte, die du geteilt hast.',
  'zk.textPribehu': 'Text der Geschichte…',
  'zk.fazeTranzice': 'Phase der Transition',
  'zk.neuvadet': 'Keine Angabe',
  'zk.ukazeSeLidem': 'Die Geschichte erscheint bei denen, die den Wegweiser zu dieser Phase lesen.',
  'zk.sdiletPribeh': 'Geschichte teilen',
  'zk.overEmail': 'Bestätige deine E-Mail, um eine Geschichte zu teilen',
  'zk.zadnePribehy': 'Noch keine Geschichten. Sei die erste Person.',
  'zk.nazevPribehu': 'Der Titel deiner Geschichte…',
  'zk.pribehP': 'Geschichte *',
  'zk.sdilejteZkusenost': 'Teile deine Erfahrung mit der Community…',
  'zk.chybaNacist': 'Die Geschichten konnten nicht geladen werden',
  'zk.vyplnteNadpis': 'Füll Überschrift und Text aus',
  'zk.spatnyOdkaz': 'Der Bildlink muss mit http://, https:// oder / anfangen',
  'zk.sdilen': 'Geschichte geteilt.',
  'zk.chybaSdilet': 'Teilen hat nicht geklappt',
  'zk.opravduSmazat': 'Diese Geschichte löschen?',
  'zk.smazan': 'Geschichte gelöscht',
  'zk.aktualizovan': 'Geschichte aktualisiert.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Deine E-Mail ist noch nicht bestätigt. Bestätige sie bitte.',
  'ram.odesilam': 'Wird geschickt…',
  'ram.znovuOdeslat': 'Nochmal schicken',
  'ram.chceteUpozorneni': 'Möchtest du bei neuen Nachrichten benachrichtigt werden?',
  'ram.tedNe': 'Jetzt nicht',
  'ram.paticka': '© 2026 Bloom – ein privater Raum für die trans Community',
  'ram.zasadyKomunity': 'Regeln der Community',
  'ram.prekladNeovereny': 'Diese Übersetzung hat noch niemand gelesen, der diese Sprache spricht. Wenn etwas holprig klingt, sag Bescheid.',
  'ram.nahlasitProblem': 'Problem melden',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Administration',
  'ot.overenyPravnik': 'Geprüfte:r Jurist:in',
  'ot.overenyOdbornik': 'Geprüfte Fachperson',
  'ot.odznakJinaZeme': (p) => `Dieses Abzeichen gilt nur für: ${p.zeme}`,
  'ot.otazkyKomunity': 'Fragen der Community',
  'ot.pridatOtazku': 'Frage hinzufügen',
  'ot.novaOtazka': 'Neue Frage',
  'ot.naCoSeZeptat': 'Was möchtest du fragen?',
  'ot.otazkaSeZobrazi': 'Deine Frage sehen andere Mitglieder der Community, die sie beantworten können.',
  'ot.otazkaP': 'Frage *',
  'ot.oblastTema': 'Bereich / Thema',
  'ot.vseObecna': 'Alles (allgemeine Frage)',
  'ot.odeslatOtazku': 'Frage schicken',
  'ot.overEmail': 'Bestätige deine E-Mail, um eine Frage zu stellen',
  'ot.zadneOtazky': 'Noch keine Fragen. Sei die erste Person.',
  'ot.hlasu': (p) => (p.pocet === 1 ? 'Stimme' : 'Stimmen'),
  'ot.odpovedi': (p) => (p.pocet === 1 ? 'Antwort' : 'Antworten'),
  'ot.zadneOdpovedi': 'Noch keine Antworten.',
  'ot.napisteOdpoved': 'Schreib eine Antwort…',
  'ot.jenPravnici': 'Fragen in Rechtliche Hilfe beantworten geprüfte Jurist:innen und die Administration.',
  'ot.smazatOtazku': 'Diese Frage löschen?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Angebote und Gesuche',
  'cp.zadneNabidky': 'Keine Angebote',
  'cp.napsatZpravu': 'Nachricht schreiben',
  'cp.nahlasitUzivatele': 'Person melden',
  'cp.nahlasitKoho': (p) => `${p.kdo} melden`,
  'cp.popisteDuvod': 'Beschreib, warum du meldest. Die Administration sieht die Meldung.',
  'cp.zustaneteAnonymni': 'Die Meldung bekommt die Administration. Du bleibst anonym.',
  'cp.duvodP': 'Grund *',
  'cp.vybertDuvod': 'Grund wählen…',
  'cp.nevhodneChovani': 'Unangemessenes Verhalten',
  'cp.falesnyProfil': 'Falsches Profil',
  'cp.jinyProblem': 'Anderes Problem',
  'cp.popisVolitelny': 'Beschreibung',
  'cp.volitelny': '(optional)',
  'cp.popisteSituaci': 'Beschreib die Situation genauer…',
  'cp.odeslatNahlaseni': 'Meldung schicken',
  'cp.vyberteDuvodChyba': 'Wähl einen Grund für die Meldung',
  'cp.nahlaseniOdeslano': 'Die Meldung ist bei der Administration',
  'cp.chybaNahlaseni': 'Die Meldung konnte nicht geschickt werden',
  'gal.chranenoHeslem': 'Passwortgeschützt',
  'gal.soukromi': 'Privatsphäre',
  'gal.nahravam': 'Wird hochgeladen…',
  'gal.pridatFotku': 'Foto hinzufügen',
  'gal.nastaveniSoukromi': 'Privatsphäre der Galerie',
  'gal.verejna': 'Öffentlich',
  'gal.chranenaHeslem': 'Passwortgeschützt',
  'gal.nastaveniUlozeno': 'Galerie-Einstellungen gespeichert',
  'gal.jeChranena': 'Diese Galerie ist passwortgeschützt',
  'gal.zadneFotky': 'Noch keine Fotos. Füg das erste hinzu.',
  'gal.otagovat': 'Person markieren',
  'gal.hledatUzivatele': 'Person suchen…',
  'gal.odemcena': 'Galerie entsperrt',
  'gal.spatneHeslo': 'Falsches Galerie-Passwort',
  'gal.fotkaNahrana': 'Foto hochgeladen.',
  'gal.chybaNahrat': 'Das Foto konnte nicht hochgeladen werden',
  'gal.fotkaSmazana': 'Foto gelöscht',
  'gal.jizOtagovan': 'Diese Person ist schon markiert',
  'gal.otagovan': (p) => `Markiert: ${p.kdo}`,
  'gal.chybaTag': 'Die Markierung konnte nicht hinzugefügt werden',
  'gal.soukromiGalerie': 'Privatsphäre der Galerie',
  'gal.verejnaGalerie': 'Öffentliche Galerie',

  'ram.povolit': 'Erlauben',
  'ram.oProjektu': 'Über das Projekt',
  'ram.kontakt': 'Kontakt',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Weltkarte – klick auf ein Land, um es zu öffnen',
  'mapa.priblizit': 'Heranzoomen',
  'mapa.oddalit': 'Herauszoomen',
  'mapa.celySvet': 'Zurück zur ganzen Welt',
  'mapa.chybaNacteni': 'Die Karte konnte nicht geladen werden',
  'mapa.chybaZkusteSeznam': 'Die Karte konnte nicht geladen werden. Versuch die Länderliste unten.',
  'mapa.teprveRoste': 'Bloom fängt hier gerade erst an',
  'mapa.napovedaDotyk': 'Zieh die Karte zum Bewegen; zoome mit zwei Fingern, per Doppeltipp oder mit den Tasten. Du musst sie nicht benutzen — Suche und die vollständige Länderliste sind darunter.',
  'obsah.specialists': (p) => (p.pocet === 1 ? 'Fachperson' : 'Fachpersonen'),
  'obsah.organizations': (p) => (p.pocet === 1 ? 'Organisation' : 'Organisationen'),
  'obsah.events': (p) => (p.pocet === 1 ? 'Veranstaltung' : 'Veranstaltungen'),
  'obsah.pageants': (p) => (p.pocet === 1 ? 'Wettbewerb' : 'Wettbewerbe'),
  'obsah.resources': (p) => (p.pocet === 1 ? 'Ressource' : 'Ressourcen'),
  'obsah.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'Eintrag' : 'Einträge'}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Wo bist du zu Hause?',
  'domov.popis': 'Danach zeigt dir Bloom, was in deiner Nähe ist. Stöbern kannst du in jedem Land — dein '
      + 'Heimatland ändert sich dadurch nicht. Es wird nirgends veröffentlicht und du kannst es jederzeit ändern.',
  'domov.preskocit': 'Überspringen',
  'domov.najitZemi': 'Land finden…',
  'domov.nicNeodpovida': 'Nichts passt. Versuch eine andere Suche.',
  'domov.klikniDoMapy': 'Du kannst auch einfach oben auf der Karte auf ein Land klicken.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Beitrag',
  'typ.users': 'Person',
  'typ.specialists': 'Fachperson',
  'typ.services': 'Angebot',
  'typ.articles': 'Rechtliche Hilfe',
  'typ.questions': 'Frage der Community',
  'typ.reviews': 'Bewertung einer Fachperson',
  'nav.emailNeoveren': 'E-Mail nicht bestätigt',
  'nav.neovereny': 'Nicht bestätigt',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Etwas funktioniert nicht',
  'chyba.navrh': 'Ein Verbesserungsvorschlag',
  'chyba.bezpecnost': 'Ein Sicherheitsproblem',
  'chyba.jiny': 'Etwas anderes',
  'chyba.vyberteTyp': 'Wähl bitte die Art des Problems',
  'chyba.popisteProsim': 'Beschreib bitte das Problem',
  'chyba.odeslano': 'Meldung geschickt, danke!',
  'chyba.chybaOdeslat': 'Die Meldung konnte nicht geschickt werden',
  'chyba.napisteNam': 'Schreib uns, was passiert ist — das hilft uns beim Beheben.',
  'chyba.typProblemu': 'Art des Problems',
  'chyba.popisProblemu': 'Was passiert ist',
  'chyba.popisPriklad': 'Beschreib, was passiert ist, was du erwartet hast und was stattdessen kam…',
  'chyba.priloha': 'Automatisch dabei: die aktuelle Seite, die Uhrzeit und Angaben zu deinem Browser.',
  'chyba.odeslatHlaseni': 'Meldung schicken',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Schreib den Inhalt…',
  'ed.tucne': 'Fett (Strg+B)',
  'ed.kurziva': 'Kursiv (Strg+I)',
  'ed.odrazky': 'Aufzählung',
  'ed.vlozitOdkaz': 'Link einfügen',
  'ed.vlozitTabulku': 'Tabelle einfügen',
  'ed.radky': 'Zeilen',
  'ed.sloupce': 'Spalten',
  'ed.vlozit': 'Einfügen',
  'ed.barva.cerna': 'Schwarz',
  'ed.barva.seda': 'Grau',
  'ed.barva.fialova': 'Lila',
  'ed.barva.ruzova': 'Rosa',
  'ed.barva.modra': 'Blau',
  'ed.barva.zelena': 'Grün',
  'ed.barva.cervena': 'Rot',
  'ed.barva.oranzova': 'Orange',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Dieser Bestätigungslink ist nicht gültig.',
  'over.hotovo': 'Deine E-Mail ist bestätigt.',
  'over.odkazVyprsel': 'Der Bestätigungslink ist ungültig oder abgelaufen.',
  'over.overuji': 'E-Mail wird bestätigt…',
  'over.cekejte': 'Einen Moment bitte.',
  'over.overen': 'E-Mail bestätigt.',
  'over.plnyPristup': 'Jetzt hast du vollen Zugang zu allem in Bloom.',
  'over.prejitNaBloom': 'Zu Bloom',
  'over.selhalo': 'Die Bestätigung hat nicht geklappt',
  'over.zpetNaPrihlaseni': 'Zurück zur Anmeldung',
  'oauth.ucetNenalezen': 'Konto nicht gefunden',
  'oauth.neexistujeGoogle': 'Zu diesem Google-Konto gibt es kein Bloom-Konto. Registrier dich bitte zuerst.',
  'oauth.neexistujeFacebook': 'Zu diesem Facebook-Konto gibt es kein Bloom-Konto. Registrier dich bitte zuerst.',
  'oauth.registrovatGoogle': 'Mit Google registrieren',
  'oauth.registrovatFacebook': 'Mit Facebook registrieren',
  'oauth.prihlasujiGoogle': 'Anmeldung mit Google…',
  'oauth.prihlasujiFacebook': 'Anmeldung mit Facebook…',
  'oauth.facebookSelhalo': 'Die Anmeldung mit Facebook hat nicht geklappt',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Wird geladen…',
  'obecne.nezadano': '— nicht angegeben —',
  'obecne.neplatnaHodnota': 'Dieser Wert ist nicht gültig.',
  'obecne.strankovani': 'Seitenwechsel',
  'navrh.doplnteNazev': 'Füll bitte den Namen aus.',
  'navrh.vyberteZemi': 'Wähl bitte ein Land.',
  'navrh.doplnte': (p) => `Füll bitte aus: ${p.co}.`,
  'kat.overenoZaznam': 'Geprüft, dass der Eintrag der Wirklichkeit entspricht',
  'kat.prihlaskyDo': (p) => `Anmeldung bis ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Profil',
  'profil.zalozkaGalerie': 'Galerie',
  'pf.lokalita': 'Ort',

  'cesta.legendaBarev': 'Farblegende',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${p.pocet === 1 ? 'Ergebnis' : 'Ergebnisse'})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Lange blonde Haare',
  'avatar.fem-lavender': 'Lila Haare',
  'avatar.fem-peach': 'Bob mit Pony',
  'avatar.fem-dark': 'Lange dunkle Haare',
  'avatar.fem-straight': 'Rote Haare',
  'avatar.fem-ponytail': 'Pferdeschwanz',
  'avatar.masc-blue': 'Kurze blonde Haare',
  'avatar.masc-teal': 'Zerzauste Haare',
  'avatar.masc-gray': 'Graue Haare',
  'avatar.masc-short': 'Igelschnitt',
  'avatar.nb-mint': 'Mintgrüne Haare',
  'avatar.nb-lilac': 'Hoher Dutt',
  'avatar.nb-curly': 'Kurze Locken',
  'avatar.nb-sage': 'Schulterlange Haare',
  'avatar.nb-mohawk': 'Irokese',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Rasierter Kopf',
  'avatar.nb-glasses': 'Brille',
  'avatar.animal-cat': 'Katze',
  'avatar.animal-fox': 'Fuchs',
  'avatar.animal-rabbit': 'Hase',
  'avatar.sym-flower': 'Blume',
  'avatar.sym-butterfly': 'Schmetterling',
  'avatar.sym-star': 'Stern',
  'avatar.custom': 'Eigenes Foto hochladen',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Wir haben dich nach einer Weile ohne Aktivität abgemeldet.',
  'odhl.necinnostPopis': 'Bloom lässt die Anmeldung nicht laufen, wenn niemand da ist.',
  'odhl.zaChvili': 'Wir melden dich gleich ab',
  'odhl.zaChviliPopis': 'Berühr jederzeit den Bildschirm oder die Tastatur und du bleibst angemeldet.',

  'reg.avatarSymboly': 'Symbole',

  'avatar.fem-bun': 'Dutt',
  'avatar.masc-navy': 'Voller Bart',
  'avatar.masc-brown': 'Seitenscheitel',
  'avatar.masc-goatee': 'Kinnbart',
  'avatar.nb-freckles': 'Sommersprossen',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Eule',
  'avatar.sym-rainbow': 'Regenbogen',
  'avatar.sym-heart': 'Herz',
  'avatar.sym-lotus': 'Lotus (Bloom)',

  'reg.potvrditHeslo': 'Passwort bestätigen',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Erstellen',
  'obecne.sdilet': 'Teilen',
  'obecne.opravneni': 'Berechtigung',
  'obecne.pristupGalerie': 'Zum Hochladen eines Fotos brauchen wir Zugriff auf deine Galerie.',
  'obecne.vsechnyRegiony': 'Alle Regionen',
  'obecne.cesko': 'Tschechien',
  'obecne.odbornici': 'Fachleute',
  'obecne.zadnaZprava': 'Keine Nachricht',
  'ucet.vyplnteEmailHeslo': 'Gib E-Mail und Passwort ein',
  'ucet.spatneUdaje': 'E-Mail oder Passwort stimmt nicht',
  'ucet.googleSelhalo': 'Anmeldung mit Google fehlgeschlagen',
  'ucet.skrytHeslo': 'Passwort verbergen',
  'ucet.emailOveren': 'Deine E-Mail wurde bestätigt.',
  'ucet.emailPriklad': 'du@email.de',
  'ucet.overeniSelhalo': 'Die Überprüfung ist fehlgeschlagen.',
  'ucet.overeniSelhaloZnovu': 'Die Überprüfung ist fehlgeschlagen. Versuch es noch einmal.',
  'ucet.komunitniHesloPovinne': 'Das Community-Passwort ist erforderlich',
  'ucet.zadejteKomunitniHeslo': 'Community-Passwort eingeben…',
  'ucet.komunitniHesloPopis': 'Bloom ist ein privater Raum. Jemand aus der Community kann dir das Passwort geben.',
  'ucet.prezdivkaMin3': 'Der Anzeigename braucht mindestens 3 Zeichen',
  'ucet.vyplntePrezdivku': 'Gib einen Anzeigenamen ein',
  'ucet.vasePrezdivka': 'Dein Anzeigename',
  'ucet.profilNeulozen': 'Profil konnte nicht gespeichert werden',
  'ucet.anoZrusitProfil': 'Ja, Profil löschen',
  'heslo.min8': 'Das Passwort braucht mindestens 8 Zeichen',
  'heslo.maleP': 'Das Passwort braucht einen Kleinbuchstaben',
  'heslo.velkeP': 'Das Passwort braucht einen Großbuchstaben',
  'heslo.cislo': 'Das Passwort braucht eine Ziffer',
  'heslo.specialni': 'Das Passwort braucht ein Sonderzeichen',
  'heslo.specialniPriklad': 'Das Passwort braucht ein Sonderzeichen (!@#$%)',
  'heslo.napoveda': 'Mind. 8 Zeichen, Großbuchstabe, Ziffer, Sonderzeichen',
  'profil.oSobe': 'Kurz über dich…',
  'profil.zajmenaOna': 'sie/ihr',
  'profil.zajmenaJine': 'andere',
  'profil.doplnujiciText': 'Optionale Ergänzung…',
  'profil.prikladOboru': 'z. B. plastische Chirurgie, Familienrecht…',
  'komunita.soukromiNadpis': 'Wir schützen die Privatsphäre',
  'komunita.soukromiText': 'Was in Bloom geteilt wird, bleibt in Bloom.',
  'komunita.podporaText': 'Bei Bloom geht es um gegenseitige Unterstützung.',
  'komunita.neniObchod': 'Bloom ist kein Marktplatz.',
  'komunita.zadneObtezovani': 'Belästigung jeder Art hat in Bloom keinen Platz.',
  'komunita.oslovovani': 'Wir sprechen alle mit dem Namen und den Pronomen an, die sie nutzen.',
  'komunita.jakakolivEtapa': 'Egal, wo du auf deinem Weg stehst.',
  'prav.kategZdravi': 'Gesundheit',
  'prav.kategPravni': 'Rechtliches',
  'prav.kategSocialni': 'Soziales',
  'ot.chybaOdpoved': 'Antwort konnte nicht gesendet werden.',
  'ot.chybaOtazka': 'Frage konnte nicht gestellt werden.',
  'zk.napisteKomentar': 'Kommentar schreiben…',
  'zpr.chybaHlasova': 'Sprachnachricht konnte nicht hochgeladen werden. Server:',
  'zpr.chybaObrazek': 'Bild konnte nicht hochgeladen werden. Server:',
  'pod.nabizim': 'Ich biete an',
  'pod.coHledate': 'Was suchst du? (z. B. Massage, Fotografie…)',
  'pod.coNabizite': 'Was bietest du an? (z. B. Kochen, Frisuren…)',
  'pod.lokalitaVolitelna': 'Ort (optional)',
  'pod.podrobnejsiPopis': 'Genauere Beschreibung *',
  'pod.vyplnteHledate': 'Sag, was du suchst.',
  'pod.vyplnteNabizite': 'Sag, was du anbietest.',
  'pod.vyplntePopis': 'Füge eine Beschreibung hinzu.',
  'pod.zadnePrispevky': 'Du hast noch keine Beiträge. Erstelle ein Angebot oder eine Anfrage.',
  'svet.vybratZemi': 'Land wählen',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Frage stellen',
  'ot.nadpis': 'Fragen und Antworten',
  'zk.pridat': 'Geschichte hinzufügen',
  'zk.novy': 'Neue Geschichte',
  'zk.smazat': 'Geschichte löschen',
  'zk.zadne': 'Noch keine Geschichten. Teile du die erste.',
  'akt.zadne': 'Noch keine Neuigkeiten.',
  'nav.clanky': 'Artikel',
  'ucet.emailOdeslan': 'E-Mail gesendet',
  'ucet.komunitniHeslo': 'Community-Passwort',
  'ucet.nemateUcet': 'Noch kein Konto? Registrieren',
  'ucet.muzetePrihlasit': 'Du kannst dich jetzt anmelden.',
  'ucet.zapomenutePopis': 'Gib deine E-Mail ein, wir schicken dir einen Link zum Zurücksetzen des Passworts.',
  'profil.oMneVolitelne': 'Über mich (optional)',
  'profil.prezdivka': 'Anzeigename',
  'profil.telefonVolitelne': 'Telefon (optional)',
  'cesta.poznamkaVolitelna': 'Persönliche Notiz (optional)',
  'okoli.vyberteLokalitu': 'Wähle oben einen Ort',
  'hled.nadpis': 'Suche',
  'hled.popis': 'Durchsuche die ganze App – Menschen, Artikel, Geschichten, Bewertungen…',
  'hled.min2': 'Gib mindestens 2 Zeichen ein, um zu suchen',
  'pod.vsechnySluzby': 'Alle Angebote',
  'domu.clenoveKomunity': 'Community-Mitglieder',
  'zpr.zadneKonverzaceHledat': 'Noch keine Unterhaltungen. Suche oben nach jemandem.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'er/ihm',
  'reg.zajmenaOni': 'dey/deren',
  'reg.zajmenaOno': 'es/seins',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Foto löschen',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Passwort für die Galerie festlegen',
  'reg.min3znaky': 'Mind. 3 Zeichen',
  'reg.zopakujteHeslo': 'Passwort wiederholen',
  'hled.vBloom': 'In Bloom suchen…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Profil bearbeiten',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Region wählen',
  'obecne.region': 'Region',
  'gal.heslemChranena': 'Passwortgeschützt',
  'gal.hesloGalerie': 'Galerie-Passwort',
  'reset.nastavitHeslo': 'Passwort festlegen',
  'reset.hesloObnoveno': 'Passwort zurückgesetzt.',
  'profil.nenalezen': 'Profil nicht gefunden',
  'obecne.nebo': 'oder',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Öffne deine Authenticator-App und übertrage die sechs Ziffern für Bloom. Du kannst stattdessen auch einen Ersatzcode eingeben.',
  'auth.sifrovaniNapoveda': 'Wenn du die Nachrichtenverschlüsselung im Web aktiviert hast, kann sich die App bei diesem Konto noch nicht anmelden. Nutze bitte bloomapp.cz im Browser.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Passwort anzeigen',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Dieses Foto löschen?',
  'dvf.zadejteKod': 'Gib den Code aus deiner App ein',
  'sif.odemknoutAplikaci': 'App entsperren',
  'profil.odeslatZnovu': 'Erneut senden',
};

export default de;
